<div class="main-content">
  <div class="loading-overlay" *ngIf="isLoading">
    <div class="text-center">
      <div class="spinner-border text-primary" role="status"></div>
    </div>
  </div>

  <div class="header-section">
    <div class="d-flex justify-content-between align-items-center">
      <div>
        <h1 class="main-title">Gestione Viaggi</h1>
        <p class="main-subtitle">
          Ricerca, monitora e chiudi i viaggi di trasporto
        </p>
      </div>

      <button
        type="button"
        class="btn btn-primary btn-create-loading-list"
        (click)="openCreateLoadingList()"
      >
        <i class="fas fa-plus me-2"></i>
        Crea borderò
      </button>
    </div>
  </div>

  <div id="filters-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-filter header-icon"></i>
          <h3>Filtri e Azioni</h3>
        </div>

        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          (click)="toggleFiltersCollapsed()"
        >
          <i
            class="fas"
            [ngClass]="isFiltersCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'"
          ></i>
        </button>
      </div>
    </div>

    <div class="card-body" *ngIf="!isFiltersCollapsed">
      <div class="row g-3">
        <!-- Riga 1: magazzino, ruolo magazzino, stato, tipo, date -->
        <div class="col-md-3" *ngIf="filterableWarehouses.length > 1">
          <label class="form-label">
            Magazzino
            <span class="text-danger" *ngIf="!canSearchWithoutWarehouse()"
              >*</span
            >
          </label>

          <div class="filter-input-wrapper">
            <ng-select
              class="filter-ng-select filter-ng-select-warehouse"
              [class.is-invalid]="filterWarehouseInvalid"
              [items]="filterableWarehouses"
              bindLabel="warehouseName"
              bindValue="warehouseCode"
              [(ngModel)]="filterWarehouse"
              (ngModelChange)="onWarehouseChange()"
              [clearable]="true"
              [searchable]="true"
              [searchFn]="searchWarehouseFn"
              placeholder="Seleziona il magazzino in cui sei"
            >
              <ng-template ng-option-tmp let-item="item">
                <span class="status-option">
                  <i class="fas fa-warehouse me-2"></i>
                  <span
                    >{{ item.warehouseName }} ({{
                      item.warehouseShortName
                    }})</span
                  >
                </span>
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                <span class="status-option">
                  <i class="fas fa-warehouse me-2"></i>
                  <span
                    >{{ item.warehouseName }} ({{
                      item.warehouseShortName
                    }})</span
                  >
                </span>
              </ng-template>
            </ng-select>
          </div>

          <div class="invalid-feedback-custom" *ngIf="filterWarehouseInvalid">
            Magazzino obbligatorio.
          </div>
        </div>

        <!-- Ruolo del magazzino selezionato nei punti del viaggio (anche intermedi) -->
        <div class="col-md">
          <label class="form-label">Ruolo magazzino</label>

          <div
            class="filter-input-wrapper"
          >
            <ng-select
              class="filter-ng-select"
              [items]="warehousePointRoles"
              bindLabel="label"
              bindValue="value"
              [(ngModel)]="filterWarehousePointRole"
              [clearable]="false"
              [searchable]="false"
            >
              <ng-template ng-option-tmp let-item="item">
                <span class="status-option">
                  <i
                    class="fas me-2"
                    [ngClass]="item.icon"
                    [style.color]="item.color"
                  ></i>
                  <span>{{ item.label }}</span>
                </span>
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                <span class="status-option">
                  <i
                    class="fas me-2"
                    [ngClass]="item.icon"
                    [style.color]="item.color"
                  ></i>
                  <span>{{ item.label }}</span>
                </span>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="col-md">
          <label class="form-label">Tipo viaggio</label>

          <div class="filter-input-wrapper">
            <ng-select
              class="filter-ng-select"
              [items]="availableTripTypes"
              bindLabel="label"
              bindValue="value"
              [(ngModel)]="filterTripType"
              [clearable]="false"
              [searchable]="false"
            >
              <ng-template ng-option-tmp let-item="item">
                <span class="status-option">
                  <i
                    class="fas me-2"
                    [ngClass]="item.icon"
                    [style.color]="item.color"
                  ></i>
                  <span>{{ item.label }}</span>
                </span>
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                <span class="status-option">
                  <span class="status-pill" [style.borderColor]="item.color">
                    <i
                      class="fas me-2"
                      [ngClass]="item.icon"
                      [style.color]="item.color"
                    ></i>
                    <span>{{ item.label }}</span>
                  </span>
                </span>
              </ng-template>
            </ng-select>
          </div>
        </div>
        
        
        <!-- Date (stessa riga) -->
        <div class="col-md-3">
          <label class="form-label">Data creazione viaggio</label>

          <div class="date-range-filter">
            <button
              class="shift-btn"
              type="button"
              (click)="shiftCreatedDates(-1)"
              matTooltip="Indietro di 1 giorno"
              matTooltipPosition="below"
              matTooltipShowDelay="200"
            >
              <i class="fa-solid fa-caret-left"></i>
            </button>

            <div class="date-range-inputs">
              <div class="filter-input-wrapper">
                <i class="fas fa-calendar-plus filter-icon"></i>
                <input type="date" [(ngModel)]="createdDateFromStr" />
              </div>
              <div class="filter-input-wrapper">
                <i class="fas fa-calendar-check filter-icon"></i>
                <input type="date" [(ngModel)]="createdDateToStr" />
              </div>
            </div>

            <button
              class="shift-btn"
              type="button"
              (click)="shiftCreatedDates(1)"
              matTooltip="Avanti di 1 giorno"
              matTooltipPosition="below"
              matTooltipShowDelay="200"
            >
              <i class="fa-solid fa-caret-right"></i>
            </button>
          </div>
        </div>

        <div class="col-md-3">
          <label class="form-label">Data richiesta documenti</label>

          <div class="date-range-filter">
            <button
              class="shift-btn"
              type="button"
              (click)="shiftRequestDates(-1)"
              matTooltip="Indietro di 1 giorno"
              matTooltipPosition="below"
              matTooltipShowDelay="200"
            >
              <i class="fa-solid fa-caret-left"></i>
            </button>

            <div class="date-range-inputs">
              <div class="filter-input-wrapper">
                <i class="fas fa-calendar-plus filter-icon"></i>
                <input type="date" [(ngModel)]="requestDateFromStr" />
              </div>
              <div class="filter-input-wrapper">
                <i class="fas fa-calendar-check filter-icon"></i>
                <input type="date" [(ngModel)]="requestDateToStr" />
              </div>
            </div>

            <button
              class="shift-btn"
              type="button"
              (click)="shiftRequestDates(1)"
              matTooltip="Avanti di 1 giorno"
              matTooltipPosition="below"
              matTooltipShowDelay="200"
            >
              <i class="fa-solid fa-caret-right"></i>
            </button>
          </div>
        </div>

        <div class="w-100 mt-0"></div>

        <div class="col-md-1">
          <label class="form-label">Stato viaggio</label>

          <div class="filter-input-wrapper">
            <ng-select
              class="filter-ng-select"
              [items]="availableStatuses"
              bindLabel="label"
              bindValue="value"
              [(ngModel)]="filterStatus"
              [clearable]="false"
              [searchable]="false"
            >
              <ng-template ng-option-tmp let-item="item">
                <span class="status-option">
                  <i
                    class="fas me-2"
                    [ngClass]="item.icon"
                    [style.color]="item.color"
                  ></i>
                  <span>{{ item.label }}</span>
                </span>
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                <span class="status-option">
                  <span class="status-pill" [style.borderColor]="item.color">
                    <i
                      class="fas me-2"
                      [ngClass]="item.icon"
                      [style.color]="item.color"
                    ></i>
                    <span>{{ item.label }}</span>
                  </span>
                </span>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="col-md">
          <label class="form-label">Codice viaggio</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-hashtag filter-icon"></i>
            <input
              type="text"
              class="form-control"
              placeholder="Codice viaggio"
              [(ngModel)]="searchTripCode"
            />
          </div>
        </div>

        <div class="col-md">
          <label class="form-label">Codice borderò</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-clipboard-list filter-icon"></i>
            <input
              type="text"
              class="form-control"
              placeholder="Codice borderò"
              [(ngModel)]="searchLoadingListCode"
            />
          </div>
        </div>

        <div class="col-md">
          <label class="form-label">Codice doc. trasporto</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-file-lines filter-icon"></i>
            <input
              type="text"
              class="form-control"
              placeholder="Codice documento"
              [(ngModel)]="searchTransportDocumentCode"
            />
          </div>
        </div>

        <div class="col-md">
          <label class="form-label">Codice collo</label>
          <div class="filter-input-wrapper">
            <i class="fas fa-box filter-icon"></i>
            <input
              type="text"
              class="form-control"
              placeholder="Codice collo"
              [(ngModel)]="searchParcelCode"
            />
          </div>
        </div>

        <div class="col-md-3" *ngIf="filterableWarehouses.length > 1">
          <label class="form-label">Magazzino partenza</label>

          <div class="filter-input-wrapper-warehouse">
            <i class="fas fa-arrow-up filter-icon-warehouse"></i>

            <ng-select
              class="filter-ng-select filter-ng-select-warehouse"
              [items]="filterableWarehouses"
              bindLabel="warehouseName"
              bindValue="warehouseCode"
              [(ngModel)]="filterWarehouseFrom"
              [clearable]="true"
              [searchable]="true"
              [searchFn]="searchWarehouseFn"
              placeholder="Tutti"
            >
              <ng-template ng-option-tmp let-item="item">
                <span class="status-option">
                  <i class="fas fa-warehouse me-2"></i>
                  <span
                    >{{ item.warehouseName }} ({{
                      item.warehouseShortName
                    }})</span
                  >
                </span>
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                <span class="status-option">
                  <i class="fas fa-warehouse me-2"></i>
                  <span
                    >{{ item.warehouseName }} ({{
                      item.warehouseShortName
                    }})</span
                  >
                </span>
              </ng-template>
            </ng-select>
          </div>
        </div>

        <div class="col-md-3" *ngIf="filterableWarehouses.length > 1">
          <label class="form-label">Magazzino arrivo</label>

          <div class="filter-input-wrapper-warehouse">
            <i class="fas fa-arrow-down filter-icon-warehouse"></i>

            <ng-select
              class="filter-ng-select filter-ng-select-warehouse"
              [items]="filterableWarehouses"
              bindLabel="warehouseName"
              bindValue="warehouseCode"
              [(ngModel)]="filterWarehouseTo"
              [clearable]="true"
              [searchable]="true"
              [searchFn]="searchWarehouseFn"
              placeholder="Tutti"
            >
              <ng-template ng-option-tmp let-item="item">
                <span class="status-option">
                  <i class="fas fa-warehouse me-2"></i>
                  <span
                    >{{ item.warehouseName }} ({{
                      item.warehouseShortName
                    }})</span
                  >
                </span>
              </ng-template>

              <ng-template ng-label-tmp let-item="item">
                <span class="status-option">
                  <i class="fas fa-warehouse me-2"></i>
                  <span
                    >{{ item.warehouseName }} ({{
                      item.warehouseShortName
                    }})</span
                  >
                </span>
              </ng-template>
            </ng-select>
          </div>
        </div>
      </div>

      <div class="d-flex justify-content-end gap-2 mt-3">
        <button type="button" class="btn btn-language" (click)="resetFilters()">
          <i class="fas fa-rotate-left me-1"></i> Reset
        </button>
        <button type="button" class="btn btn-primary" (click)="search()">
          <i class="fas fa-magnifying-glass me-1"></i> Cerca
        </button>
      </div>
    </div>
  </div>

  <!-- Sezione Resoconto -->
  <div id="trip-summary-section" class="card mb-4">
    <div class="card-header">
      <div class="d-flex justify-content-between align-items-center">
        <div class="header-title">
          <i class="fas fa-chart-bar header-icon"></i>
          <h3>Resoconto</h3>
        </div>

        <button
          type="button"
          class="btn btn-sm btn-outline-secondary"
          (click)="toggleTripReportCollapsed()"
          [title]="isTripReportCollapsed ? 'Espandi' : 'Comprimi'"
        >
          <i
            class="fas"
            [ngClass]="
              isTripReportCollapsed ? 'fa-chevron-down' : 'fa-chevron-up'
            "
          ></i>
        </button>
      </div>
    </div>

    <div class="card-body" *ngIf="!isTripReportCollapsed">
      <div class="row g-3">
        <!-- PIANIFICATO -->
        <div class="col-xl-3 col-lg-4 col-md-6">
          <div
            class="summary-card summary-card--wide d-flex align-items-center p-3 rounded"
            style="background-color: rgba(245, 121, 6, 0.1)"
          >
            <div class="d-flex align-items-center">
              <i class="fas fa-calendar-day fa-2x" style="color: #f57906"></i>
              <div class="ms-3">
                <div class="fw-bold fs-4" style="color: #f57906">
                  {{ summaryTripPlanned | number }}
                </div>
                <div class="fw-bold small" style="color: #f57906">
                  Pianificato
                </div>
              </div>
            </div>

            <div class="ms-auto ps-3 border-start summary-metrics">
              <div class="d-flex gap-3">
                <div class="summary-metric">
                  <div class="summary-metric__title text-muted">Colli</div>
                  <div class="summary-metric__value fw-semibold">
                    {{ totTripPlannedItems | number }}
                  </div>
                  <div class="summary-metric__sub text-muted">
                    {{ formatKg(totTripPlannedWeight) }} •
                    {{ formatM3(totTripPlannedVolume) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- IN CORSO -->
        <div class="col-xl-3 col-lg-4 col-md-6">
          <div
            class="summary-card summary-card--wide d-flex align-items-center p-3 rounded"
            style="background-color: rgba(41, 122, 245, 0.1)"
          >
            <div class="d-flex align-items-center">
              <i class="fas fa-truck-fast fa-2x" style="color: #297af5"></i>
              <div class="ms-3">
                <div class="fw-bold fs-4" style="color: #297af5">
                  {{ summaryTripInProgress | number }}
                </div>
                <div class="fw-bold small" style="color: #297af5">In corso</div>
              </div>
            </div>

            <div class="ms-auto ps-3 border-start summary-metrics">
              <div class="d-flex gap-3">
                <div class="summary-metric">
                  <div class="summary-metric__title text-muted">Colli</div>
                  <div class="summary-metric__value fw-semibold">
                    {{ totTripInProgressItems | number }}
                  </div>
                  <div class="summary-metric__sub text-muted">
                    {{ formatKg(totTripInProgressWeight) }} •
                    {{ formatM3(totTripInProgressVolume) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- CHIUSI -->
        <div class="col-xl-3 col-lg-4 col-md-6">
          <div
            class="summary-card summary-card--wide d-flex align-items-center p-3 rounded"
            style="background-color: rgba(25, 135, 84, 0.1)"
          >
            <div class="d-flex align-items-center">
              <i class="fas fa-lock fa-2x" style="color: #198754"></i>
              <div class="ms-3">
                <div class="fw-bold fs-4" style="color: #198754">
                  {{ summaryTripClosed | number }}
                </div>
                <div class="fw-bold small" style="color: #198754">Chiusi</div>
              </div>
            </div>

            <div class="ms-auto ps-3 border-start summary-metrics">
              <div class="d-flex gap-3">
                <div class="summary-metric">
                  <div class="summary-metric__title text-muted">Colli</div>
                  <div class="summary-metric__value fw-semibold">
                    {{ totTripClosedItems | number }}
                  </div>
                  <div class="summary-metric__sub text-muted">
                    {{ formatKg(totTripClosedWeight) }} •
                    {{ formatM3(totTripClosedVolume) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        <!-- ELIMINATI -->
        <div class="col-xl-3 col-lg-4 col-md-6">
          <div
            class="summary-card summary-card--wide d-flex align-items-center p-3 rounded"
            style="background-color: rgba(220, 53, 69, 0.1)"
          >
            <div class="d-flex align-items-center">
              <i class="fas fa-trash fa-2x" style="color: #dc3545"></i>
              <div class="ms-3">
                <div class="fw-bold fs-4" style="color: #dc3545">
                  {{ summaryTripDeleted | number }}
                </div>
                <div class="fw-bold small" style="color: #dc3545">
                  Eliminati
                </div>
              </div>
            </div>

            <div class="ms-auto ps-3 border-start summary-metrics">
              <div class="d-flex gap-3">
                <div class="summary-metric">
                  <div class="summary-metric__title text-muted">Colli</div>
                  <div class="summary-metric__value fw-semibold">
                    {{ totTripDeletedItems | number }}
                  </div>
                  <div class="summary-metric__sub text-muted">
                    {{ formatKg(totTripDeletedWeight) }} •
                    {{ formatM3(totTripDeletedVolume) }}
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <div class="card-container" *ngIf="isLoading && trips.length === 0">
    <div class="card-skeleton" *ngFor="let s of [1, 2, 3]">
      <div class="skeleton-title"></div>
      <div class="skeleton-text"></div>
      <div class="skeleton-table">
        <div class="skeleton-row" *ngFor="let r of [1, 2, 3, 4]"></div>
      </div>
    </div>
  </div>

  <div class="empty-state" *ngIf="!isLoading && trips.length === 0">
    <i class="fas fa-route fa-2x mb-2 d-block"></i>
    Nessun viaggio trovato con i filtri selezionati
  </div>

  <!-- Toolbar azioni sulla lista viaggi -->
  <div class="trips-toolbar" *ngIf="trips.length > 0">
    <label class="select-all-checkbox">
      <input
        type="checkbox"
        [checked]="areAllTripsSelected()"
        (change)="toggleSelectAllTrips()"
      />
      <span>Seleziona tutto</span>
    </label>

    <span class="selected-count" *ngIf="selectedTripsCount > 0">
      {{ selectedTripsCount }} selezionat{{
        selectedTripsCount === 1 ? "o" : "i"
      }}
    </span>

    <div class="flex-spacer"></div>

    <div class="per-page-selector">
      <div class="btn-group btn-group-sm pagination-selector" role="group">
        <button
          type="button"
          class="btn"
          [ngClass]="
            itemsPerPage === 5 ? 'btn-secondary' : 'btn-outline-secondary'
          "
          (click)="setTripsItemsPerPage(5)"
          matTooltip="5 viaggi per pagina"
          matTooltipShowDelay="200"
        >
          5
        </button>
        <button
          type="button"
          class="btn"
          [ngClass]="
            itemsPerPage === 10 ? 'btn-secondary' : 'btn-outline-secondary'
          "
          (click)="setTripsItemsPerPage(10)"
          matTooltip="10 viaggi per pagina"
          matTooltipShowDelay="200"
        >
          10
        </button>
        <button
          type="button"
          class="btn"
          [ngClass]="
            itemsPerPage === 25 ? 'btn-secondary' : 'btn-outline-secondary'
          "
          (click)="setTripsItemsPerPage(25)"
          matTooltip="25 viaggi per pagina"
          matTooltipShowDelay="200"
        >
          25
        </button>
        <button
          type="button"
          class="btn"
          [ngClass]="
            itemsPerPage === 50 ? 'btn-secondary' : 'btn-outline-secondary'
          "
          (click)="setTripsItemsPerPage(50)"
          matTooltip="50 viaggi per pagina"
          matTooltipShowDelay="200"
        >
          50
        </button>
        <button
          type="button"
          class="btn"
          [ngClass]="
            itemsPerPage === 100 ? 'btn-secondary' : 'btn-outline-secondary'
          "
          (click)="setTripsItemsPerPage(100)"
          matTooltip="100 viaggi per pagina"
          matTooltipShowDelay="200"
        >
          100
        </button>
      </div>
    </div>

    <button
      type="button"
      class="btn btn-close-trip btn-sm"
      [disabled]="selectableSelectedTrips.length === 0"
      (click)="openBulkSendDocsConfirm()"
    >
      <i class="fas fa-envelope-open me-2"></i>
      Invia bolle selezionati{{
        selectableSelectedTrips.length > 0
          ? " (" + selectableSelectedTrips.length + ")"
          : ""
      }}
    </button>

    <button
      type="button"
      class="btn btn-outline-secondary btn-sm"
      (click)="toggleAllTripsCollapsed()"
    >
      <i
        class="fas me-1"
        [ngClass]="areAllTripsCollapsed() ? 'fa-angles-down' : 'fa-angles-up'"
      ></i>
      {{ areAllTripsCollapsed() ? "Espandi tutti" : "Comprimi tutti" }}
    </button>

    <div class="meta-stat" matTooltip="Viaggi" matTooltipPosition="above">
      <i class="fas fa-route"></i> {{ totalTripsCount }}
    </div>
  </div>

  <!-- Lista viaggi (card) -->
  <div class="trip-list" *ngIf="!isLoading || trips.length > 0">
    <div
      class="trip-card"
      *ngFor="let trip of trips; trackBy: trackByTripId"
      [style.borderLeft]="'4px solid ' + getStatusMeta(trip.tripStatus).color"
    >
      <div class="trip-card-header">
        <div class="trip-card-header-top">
          <div class="trip-card-header-left">
            <label
              class="trip-select-checkbox"
              (click)="$event.stopPropagation()"
            >
              <input
                type="checkbox"
                [checked]="isTripSelected(trip)"
                (change)="toggleTripSelection(trip)"
              />
            </label>

            <div class="trip-code">{{ trip.tripCode }}</div>

            <span
              class="status-chip"
              [style.color]="getStatusMeta(trip.tripStatus).color"
              [style.background]="
                hexToRgba(getStatusMeta(trip.tripStatus).color, 0.12)
              "
              [style.borderColor]="
                hexToRgba(getStatusMeta(trip.tripStatus).color, 0.4)
              "
            >
              <span
                class="status-dot-pulse"
                [class.pulse]="trip.tripStatus === 'IN_PROGRESS'"
                [style.background]="getStatusMeta(trip.tripStatus).color"
              ></span>
              <i
                class="fas me-1"
                [ngClass]="getStatusMeta(trip.tripStatus).icon"
              ></i>
              {{ getStatusMeta(trip.tripStatus).label }}
            </span>

            <span
              class="status-chip"
              [style.color]="getTripTypeMeta(trip).color"
              [style.background]="'#f1f3f5'"
              [style.borderColor]="hexToRgba(getTripTypeMeta(trip).color, 0.4)"
            >
              <i class="fas me-1" [ngClass]="getTripTypeMeta(trip).icon"></i>
              {{ getTripTypeMeta(trip).label }}
            </span>
          </div>

          <div
            class="trip-route-endpoints"
            *ngIf="getSortedPoints(trip).length > 0"
            [style.background]="
              hexToRgba(getStatusMeta(trip.tripStatus).color, 0.12)
            "
          >
            <!-- Tutti i punti del viaggio in sequenza -->
            <ng-container
              *ngFor="
                let ep of getRouteEndpoints(trip);
                let last = last;
                trackBy: trackByIndex
              "
            >
              <span
                class="endpoint-name"
                [matTooltip]="ep.tooltip"
                [matTooltipDisabled]="!ep.truncated"
                matTooltipPosition="above"
                >{{ ep.label }}</span
              >
              <i
                *ngIf="!last"
                class="fas fa-arrow-right-long endpoint-arrow"
              ></i>
            </ng-container>
          </div>

          <button
            type="button"
            class="trip-collapse-btn"
            (click)="toggleTripCollapsed(trip)"
            [matTooltip]="
              isTripCollapsed(trip) ? 'Espandi viaggio' : 'Comprimi viaggio'
            "
            matTooltipPosition="left"
          >
            <i
              class="fas"
              [ngClass]="
                isTripCollapsed(trip) ? 'fa-chevron-down' : 'fa-chevron-up'
              "
            ></i>
          </button>
        </div>

        <div class="trip-card-header-meta">
          <div
            class="meta-chip"
            *ngIf="trip.tripExternalTripCode"
            matTooltip="Codice viaggio esterno"
            matTooltipPosition="above"
          >
            <i class="fas fa-link"></i> {{ trip.tripExternalTripCode }}
          </div>
          <div class="meta-chip">
            <i class="fas fa-calendar-plus"></i> Creato il
            {{ formatDateTime(trip.tripCreatedAt) }}
          </div>
          <div
            class="meta-chip meta-chip-warning"
            *ngIf="isTripDocsPending(trip)"
          >
            <i class="fas fa-hourglass-half"></i> Invio bolle in attesa
            (richiesto il {{ formatDateTime(trip.tripDocsSendRequestedAt) }}
            {{ getUserNameSendRequestedBy(trip) }})
          </div>
          <div class="meta-chip meta-chip-success" *ngIf="isTripDocsSent(trip)">
            <i class="fas fa-envelope-open"></i> Bolle inviate il
            {{ formatDateTime(trip.tripDocsSentAt) }}
            {{ getUserNameSendRequestedBy(trip) }}
          </div>
          <div
            class="meta-chip"
            *ngIf="trip.tripTourGroupNames?.length"
            [matTooltip]="getTripTourGroupsTooltip(trip)"
            matTooltipPosition="above"
            [matTooltipDisabled]="
              (trip.tripTourGroupNames?.length || 0) <= maxTripTourGroupsShown
            "
          >
            <i class="fas fa-route"></i> {{ getTripTourGroupsLabel(trip) }}
          </div>
          <div class="meta-chip meta-chip-warning" *ngFor="let tourRouting of trip.tripTourRoutingsWithoutGroup">
            <i class="fas fa-route"></i> {{ tourRouting }}
          </div>

          <div class="trip-header-fields">
            <div
              class="meta-chip"
              [class.meta-chip-empty]="!trip.tripCarrierCode"
              matTooltip="Vettore"
              matTooltipPosition="above"
            >
              <i class="fas fa-building"></i>
              {{
                trip.tripCarrierCode
                  ? getCarrierName(trip.tripCarrierCode)
                  : "-"
              }}
            </div>
            <div
              class="meta-chip"
              [class.meta-chip-empty]="!trip.tripPlateNo"
              matTooltip="Targa rimorchio"
              matTooltipPosition="above"
            >
              <i class="fas fa-trailer"></i> {{ trip.tripPlateNo || "-" }}
            </div>
            <button
              type="button"
              class="meta-edit-btn"
              *ngIf="canEditTripHeader(trip)"
              (click)="openTripHeaderPopup(trip, $event)"
              matTooltip="Modifica vettore e targa rimorchio"
              matTooltipPosition="above"
            >
              <i class="fas fa-pen"></i>
            </button>
          </div>

          <div class="flex-spacer"></div>

          <div
            class="meta-stat"
            matTooltip="Punti Carico/Scarico"
            matTooltipPosition="above"
          >
            <i class="fas fa-warehouse"></i> {{ getSortedPoints(trip).length }}
          </div>
          <div
            class="meta-stat"
            matTooltip="Borderò collegati"
            matTooltipPosition="above"
          >
            <i class="fas fa-clipboard-list"></i>
            {{ getVisibleLoadingLists(trip).length }}
          </div>
          <div
            class="meta-stat"
            matTooltip="Documenti di trasporto"
            matTooltipPosition="above"
          >
            <i class="fas fa-file-lines"></i>
            {{ getVisibleTransportDocuments(trip).length }}
          </div>
          <div
            class="meta-stat"
            matTooltip="Colli totali"
            matTooltipPosition="above"
          >
            <i class="fas fa-box"></i> {{ trip.parcelsCount || 0 }}
          </div>
        </div>
      </div>

      <div class="trip-card-body" *ngIf="!isTripCollapsed(trip)">
        <!-- Tabs -->
        <div class="trip-tabs">
          <button
            type="button"
            class="trip-tab-btn"
            [class.active]="isTabActive(trip, 'route')"
            (click)="selectTab(trip, 'route')"
          >
            <i class="fas fa-route me-1"></i> Percorso
          </button>

          <button
            type="button"
            class="trip-tab-btn"
            [class.active]="isTabActive(trip, 'points')"
            (click)="selectTab(trip, 'points')"
          >
            <i class="fas fa-warehouse me-1"></i> Punti Carico/Scarico
            <span class="tab-count" *ngIf="getSortedPoints(trip).length">{{
              getSortedPoints(trip).length
            }}</span>
          </button>

          <button
            type="button"
            class="trip-tab-btn"
            [class.active]="isTabActive(trip, 'loadingLists')"
            (click)="selectTab(trip, 'loadingLists')"
          >
            <i class="fas fa-clipboard-list me-1"></i> Borderò
            <span
              class="tab-count"
              *ngIf="getVisibleLoadingLists(trip).length"
              >{{ getVisibleLoadingLists(trip).length }}</span
            >
          </button>

          <button
            type="button"
            class="trip-tab-btn"
            [class.active]="isTabActive(trip, 'transportDocuments')"
            (click)="selectTab(trip, 'transportDocuments')"
          >
            <i class="fas fa-file-lines me-1"></i> Documenti di trasporto
            <span
              class="tab-count"
              *ngIf="getVisibleTransportDocuments(trip).length"
              >{{ getVisibleTransportDocuments(trip).length }}</span
            >
          </button>

          <button
            type="button"
            class="trip-tab-btn"
            [class.active]="isTabActive(trip, 'parcels')"
            (click)="selectTab(trip, 'parcels')"
          >
            <i class="fas fa-box me-1"></i> Colli
            <span class="tab-count" *ngIf="trip.parcelsCount">{{
              trip.parcelsCount
            }}</span>
          </button>
        </div>

        <div class="trip-tab-content">
          <!-- TAB 1: Percorso / timeline trip points -->
          <div
            *ngIf="isTabActive(trip, 'route')"
            class="route-timeline-wrapper"
          >
            <div
              class="route-timeline"
              [class.stretch]="trip.tripStatus === 'CLOSED'"
              *ngIf="getSortedPoints(trip).length > 0; else noPoints"
            >
              <ng-container
                *ngFor="
                  let point of getSortedPoints(trip);
                  let i = index;
                  let isLast = last;
                  trackBy: trackByPointId
                "
              >
                <div class="route-point">
                  <div
                    class="route-point-warehouse truncate"
                    [matTooltip]="
                      getPointTooltip(
                        point.tripPointWarehouseCode,
                        point.tripPointDealerCode
                      )
                    "
                    matTooltipPosition="above"
                  >
                    {{
                      getPointShortLabel(
                        point.tripPointWarehouseCode,
                        point.tripPointDealerCode
                      )
                    }}
                  </div>
                  <div
                    class="route-node"
                    [class.clickable]="isDeparturePoint(point)"
                    (click)="openRouteDetailPopup(trip, point, $event)"
                    [class.done]="getPointStatus(point) === 'CLOSED'"
                    [class.in_progress]="
                      getPointStatus(point) === 'IN_PROGRESS'
                    "
                    [class.pending]="getPointStatus(point) === 'PLANNED'"
                    [style.borderColor]="getPointStatusColor(point)"
                    [style.background]="
                      getPointStatus(point) === 'PLANNED'
                        ? '#f8f9fa'
                        : getPointStatusColor(point)
                    "
                    [matTooltip]="getMatTooltipTripPointRoutNode(point)"
                  >
                    <i
                      class="fas fa-warehouse"
                      [style.color]="getPointStatusColor(point)"
                    ></i>
                  </div>

                  <div class="route-point-info">
                    <!-- <div class="route-point-code">{{ point.tripPointCode }}</div> -->

                    <span
                      class="operation-badge"
                      [ngClass]="getOperationClass(point)"
                    >
                      <i class="fas" [ngClass]="getPointIcon(point)"></i>
                      {{ getPointOperationLabel(point) | uppercase }}
                    </span>

                    <span
                      class="point-status-badge"
                      [style.color]="getPointStatusColor(point)"
                      [style.background]="
                        hexToRgba(getPointStatusColor(point), 0.12)
                      "
                    >
                      {{ getPointStatusLabel(point) }}
                    </span>

                    <div class="route-point-dates">
                      <div
                        *ngIf="
                          point.tripPointOperation === 'LOADING' ||
                          point.tripPointOperation === 'LOADING_UNLOADING'
                        "
                        [class.text-done]="point.tripPointLoadedAt"
                      >
                        <i class="fas fa-arrow-up me-1"></i>
                        {{
                          point.tripPointLoadedAt
                            ? formatDateTime(point.tripPointLoadedAt)
                            : "In attesa carico"
                        }}
                      </div>
                      <div
                        *ngIf="
                          point.tripPointOperation === 'UNLOADING' ||
                          point.tripPointOperation === 'LOADING_UNLOADING'
                        "
                        [class.text-done]="point.tripPointUnloadedAt"
                      >
                        <i class="fas fa-arrow-down me-1"></i>
                        {{
                          point.tripPointUnloadedAt
                            ? formatDateTime(point.tripPointUnloadedAt)
                            : "In attesa scarico"
                        }}
                      </div>
                    </div>
                  </div>
                </div>

                <div
                  class="route-connector"
                  *ngIf="!isLast"
                  [ngClass]="getConnectorState(trip, i)"
                >
                  <div class="route-connector-fill"></div>
                </div>
              </ng-container>
            </div>

            <ng-template #noPoints>
              <div class="empty-state-inline">
                <i class="fas fa-route me-2"></i> Nessuna tappa registrata per
                questo viaggio
              </div>
            </ng-template>
          </div>

          <!-- TAB 2: Borderò collegati -->
          <div *ngIf="isTabActive(trip, 'loadingLists')">
            <div
              class="d-flex justify-content-end gap-2 mb-3"
              *ngIf="!isExternalTrip(trip)"
            >
              <button
                type="button"
                class="btn btn-outline-primary btn-sm"
                (click)="openLinkLoadingListsPopup(trip)"
              >
                <i class="fas fa-right-left me-1"></i>
                Collega borderò esistenti
              </button>
              <button
                type="button"
                class="btn btn-primary btn-sm btn-add-loading-list"
                (click)="openCreateLoadingList(trip)"
              >
                <i class="fas fa-plus me-2"></i>
                Aggiungi borderò
              </button>
            </div>

            <div
              class="ll-list"
              *ngIf="getVisibleLoadingLists(trip).length; else noLoadingLists"
            >
              <div
                class="ll-card"
                *ngFor="let ll of getVisibleLoadingLists(trip)"
              >
                <div class="ll-card-top">
                  <div class="ll-code">
                    <i class="fas fa-clipboard-list me-2"></i>
                    <span
                      class="clickable-code"
                      (click)="openLoadingListDetail(ll, trip)"
                      matTooltip="Apri borderò"
                      matTooltipPosition="above"
                      >{{ ll.loadingListCode }}</span
                    >
                  </div>

                  <span
                    class="badge d-inline-flex align-items-center gap-1 ms-2"
                    [ngStyle]="{
                      backgroundColor: getLoadingListTypeMeta(ll, trip).bg,
                      color: getLoadingListTypeMeta(ll, trip).color,
                    }"
                  >
                    <i
                      class="fa"
                      [ngClass]="getLoadingListTypeMeta(ll, trip).icon"
                      [ngStyle]="{
                        color: getLoadingListTypeMeta(ll, trip).color,
                      }"
                    ></i>
                    {{ getLoadingListTypeMeta(ll, trip).label }}
                  </span>

                  <div class="flex-spacer"></div>

                  <span class="link-trip-badge" *ngIf="ll.loadingListTripCode">
                    <i class="fas fa-link"></i>
                    {{ ll.loadingListTripCode }}
                  </span>

                  <button
                    type="button"
                    class="btn btn-outline-danger"
                    *ngIf="canDeleteLoadingListToTrip(ll)"
                    (click)="openDeletePopup(ll)"
                  >
                    <i class="fas fa-trash me-1"></i> Elimina borderò
                  </button>

                  <button
                    type="button"
                    class="btn btn-merge-trip"
                    *ngIf="canMergeLoadingListToTrip(ll)"
                    (click)="openMergeLoadingListToTripDialog(ll, trip)"
                    matTooltip="Sposta questo borderò su un altro viaggio"
                  >
                    <i class="fas fa-link me-1"></i> Unisci a un altro viaggio
                  </button>

                  <button
                    type="button"
                    class="btn btn-detach-trip"
                    *ngIf="canDetachLoadingListFromTrip(ll, trip)"
                    (click)="openDetachLoadingListPopup(ll, trip)"
                    matTooltip="Scollega questo borderò dal viaggio"
                  >
                    <i class="fas fa-link-slash me-1"></i> Sfila da questo
                    viaggio
                  </button>

                  <span
                    class="status-chip small"
                    [style.color]="
                      getLoadingListStatusStyle(ll.loadingListStatus).color
                    "
                    [style.background]="
                      getLoadingListStatusStyle(ll.loadingListStatus)
                        .backgroundColor
                    "
                  >
                    {{ getLoadingListStatusLabel(ll.loadingListStatus) }}
                  </span>
                </div>

                <div class="ll-meta">
                  <span *ngIf="ll.loadingListWarehouseCode"
                    ><i class="fas fa-warehouse"></i>
                    {{ getWarehouseName(ll.loadingListWarehouseCode) }}</span
                  >
                  <span *ngIf="ll.loadingListTourRoutingGroups"
                    ><i class="fas fa-route"></i>
                    {{ ll.loadingListTourRoutingGroups }}</span
                  >
                <span class="tour-without-group-badge" *ngFor="let tourRouting of ll.loadingListTourRoutingsWithoutGroup"><i class="fas fa-route"></i> {{ tourRouting }}</span>
                  <span *ngIf="ll.loadingListPlateNo"
                    ><i class="fas fa-id-card"></i>
                    {{ ll.loadingListPlateNo }}</span
                  >
                  <span
                    ><i class="fas fa-calendar"></i>
                    {{ formatDateTime(ll.loadingListCreatedAt) }}</span
                  >
                  <span
                    ><i class="fas fa-weight-hanging"></i>
                    {{ formatKg(ll.loadingListLoadedWeight) }}</span
                  >
                  <span
                    ><i class="fas fa-cube"></i>
                    {{ formatM3(ll.loadingListLoadedVolume) }}</span
                  >
                </div>

                <div class="ll-progress-row">
                  <div
                    class="ll-progress-block"
                    *ngIf="
                      !isSingleWarehouseUser() ||
                      isExternalTrip(trip) ||
                      getLoadingListType(ll, trip) === 'DEPARTURE'
                    "
                  >
                    <div class="ll-progress-label">
                      <span class="op-text-carico"
                        ><i class="fas fa-arrow-up me-1"></i>Caricati</span
                      >
                      <span class="ll-progress-value"
                        >{{ ll.loadingListLoadedCount || 0 }} /
                        {{ getLoadingListLoadedDenominator(ll) }}</span
                      >
                    </div>
                    <div class="mini-progress-bar">
                      <div
                        class="mini-progress-fill fill-carico"
                        [style.width.%]="getLoadingListLoadedPercent(ll)"
                      ></div>
                    </div>
                  </div>

                  <div
                    class="ll-progress-block"
                    *ngIf="
                      !isSingleWarehouseUser() ||
                      isExternalTrip(trip) ||
                      getLoadingListType(ll, trip) === 'ARRIVAL'
                    "
                  >
                    <div class="ll-progress-label">
                      <span class="op-text-scarico"
                        ><i class="fas fa-arrow-down me-1"></i>Scaricati</span
                      >
                      <span class="ll-progress-value"
                        >{{ getLoadingListUnloadedCount(ll) }} /
                        {{ getLoadingListUnloadedCountDen(ll) }}</span
                      >
                    </div>
                    <div class="mini-progress-bar">
                      <div
                        class="mini-progress-fill fill-scarico"
                        [style.width.%]="getLoadingListUnloadedPercent(ll)"
                      ></div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <ng-template #noLoadingLists>
              <div class="empty-state-inline">
                <i class="fas fa-clipboard-list me-2"></i> Nessun borderò
                collegato a questo viaggio
              </div>
            </ng-template>
          </div>

          <!-- TAB 3: Documenti di trasporto -->
          <div *ngIf="isTabActive(trip, 'transportDocuments')">
            <div
              class="d-flex justify-content-between align-items-center flex-wrap gap-2 mb-3"
              *ngIf="getVisibleTransportDocuments(trip).length"
            >
              <label class="doc-select-all">
                <input
                  type="checkbox"
                  [checked]="areAllDocsSelected(trip)"
                  (change)="toggleAllDocsSelection(trip)"
                />
                <span>Seleziona tutto</span>
              </label>

              <button
                type="button"
                class="btn btn-outline-secondary btn-sm"
                [disabled]="
                  getSelectedDocsForTrip(trip).length === 0 ||
                  printingBulkDocs[trip.tripId]
                "
                (click)="printSelectedTransportDocuments(trip)"
              >
                <i
                  class="fas me-2"
                  [ngClass]="
                    printingBulkDocs[trip.tripId]
                      ? 'fa-spinner fa-spin'
                      : 'fa-file-pdf'
                  "
                ></i>
                Stampa selezionati{{
                  getSelectedDocsForTrip(trip).length > 0
                    ? " (" + getSelectedDocsForTrip(trip).length + ")"
                    : ""
                }}
              </button>
            </div>

            <div
              class="table-scroll-wrapper"
              *ngIf="getVisibleTransportDocuments(trip).length; else noDocs"
            >
              <table class="manifest-table">
                <thead>
                  <tr>
                    <th class="text-center"></th>
                    <th>Codice</th>
                    <th>Tipo</th>
                    <th>Da</th>
                    <th>A</th>
                    <th>Creato il</th>
                    <th class="text-end">N° colli</th>
                    <th class="text-end">Peso / Volume</th>
                    <th class="text-center">Documento di trasporto</th>
                    <th class="text-center">Bolle</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let doc of getVisibleTransportDocuments(trip);
                      trackBy: trackByDocId
                    "
                  >
                    <td class="text-center">
                      <input
                        type="checkbox"
                        [checked]="isDocSelected(doc)"
                        (change)="toggleDocSelection(doc)"
                      />
                    </td>
                    <td class="fw-semibold">
                      <span
                        class="clickable-code"
                        (click)="openTransportDocumentParcelsPopup(trip, doc)"
                        matTooltip="Vedi colli del documento"
                        matTooltipPosition="above"
                      >
                        {{ doc.transportDocumentCode }}
                      </span>
                    </td>
                    <td>
                      <span
                        class="badge text-secondary border border-secondary"
                        style="font-size: 0.8rem"
                        >{{
                          getDocumentTypeLabel(doc.transportDocumentType)
                        }}</span
                      >
                    </td>
                    <td>
                      <span
                        [matTooltip]="
                          getPointTooltip(
                            doc.transportDocumentPointFromWarehouseCode,
                            doc.transportDocumentPointFromDealerCode,
                            doc.transportDocumentPointFromCode
                          )
                        "
                        matTooltipPosition="above"
                      >
                        {{
                          getPointShortLabel(
                            doc.transportDocumentPointFromWarehouseCode,
                            doc.transportDocumentPointFromDealerCode,
                            doc.transportDocumentPointFromCode
                          )
                        }}
                      </span>
                    </td>
                    <td>
                      <span
                        [matTooltip]="
                          getPointTooltip(
                            doc.transportDocumentPointToWarehouseCode,
                            doc.transportDocumentPointToDealerCode,
                            doc.transportDocumentPointToCode
                          )
                        "
                        matTooltipPosition="above"
                      >
                        {{
                          getPointShortLabel(
                            doc.transportDocumentPointToWarehouseCode,
                            doc.transportDocumentPointToDealerCode,
                            doc.transportDocumentPointToCode
                          )
                        }}
                      </span>
                    </td>
                    <td>
                      {{ formatDateTime(doc.transportDocumentCreatedAt) }}
                    </td>
                    <td class="text-end">
                      {{ doc.transportDocumentItemsCount || 0 }}
                    </td>
                    <td class="text-end">
                      {{ formatKg(doc.transportDocumentTotalWeight) }} •
                      {{ formatM3(doc.transportDocumentTotalVolume) }}
                    </td>
                    <td class="text-center">
                      <button
                        type="button"
                        class="header-action-btn"
                        [disabled]="printingDoc[doc.transportDocumentId]"
                        (click)="
                          printTransportDocument(doc.transportDocumentId)
                        "
                        matTooltip="Stampa PDF documento di trasporto"
                        matTooltipPosition="above"
                      >
                        <i
                          class="text-danger fas"
                          [ngClass]="
                            printingDoc[doc.transportDocumentId]
                              ? 'fa-spinner fa-spin'
                              : 'fa-file-pdf'
                          "
                        ></i>
                      </button>
                    </td>
                    <td class="text-center">
                      <button
                        type="button"
                        class="header-action-btn"
                        [disabled]="printingDDTByDoc[doc.transportDocumentId]"
                        (click)="
                          printDDTByTransportDocument(doc.transportDocumentId)
                        "
                        matTooltip="Stampa PDF di tutte le bolle del documento di trasporto"
                        matTooltipPosition="above"
                      >
                        <i
                          class="fas"
                          [ngClass]="
                            printingDDTByDoc[doc.transportDocumentId]
                              ? 'fa-spinner fa-spin'
                              : 'fa-file-lines'
                          "
                        ></i>
                      </button>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <ng-template #noDocs>
              <div class="empty-state-inline">
                <i class="fas fa-file-lines me-2"></i> Nessun documento di
                trasporto collegato a questo viaggio
              </div>
            </ng-template>
          </div>

          <!-- TAB 5: Colli -->
          <div *ngIf="isTabActive(trip, 'parcels')">
            <div
              class="d-flex justify-content-end mb-3"
              *ngIf="getParcelsForTrip(trip).length > 0"
            >
              <button
                type="button"
                class="btn btn-outline-success btn-sm"
                (click)="exportTripParcelsToExcel(trip)"
              >
                <i class="fas fa-file-excel me-2"></i>
                Esporta Excel
              </button>
            </div>

            <div class="text-center py-3" *ngIf="parcelsLoading[trip.tripId]">
              <div
                class="spinner-border spinner-border-sm text-primary"
                role="status"
              ></div>
              <span class="ms-2 text-muted">Caricamento colli...</span>
            </div>

            <div
              class="table-scroll-wrapper"
              *ngIf="
                !parcelsLoading[trip.tripId] &&
                getParcelsForTrip(trip).length > 0
              "
            >
              <table class="manifest-table">
                <thead>
                  <tr>
                    <th>Codice collo</th>
                    <th>Barcode</th>
                    <th class="text-end">Peso</th>
                    <th class="text-end">Volume</th>
                    <th>Viaggio</th>
                    <th>Documento trasporto</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let it of getParcelsForTrip(trip);
                      trackBy: trackByTransportItemId
                    "
                  >
                    <td class="fw-semibold">
                      {{ it.transportDocumentItemParcelCode || "-" }}
                    </td>
                    <td>{{ it.transportDocumentItemBarcode || "-" }}</td>
                    <td class="text-end">
                      {{ formatKg(it.transportDocumentItemParcelWeight) }}
                    </td>
                    <td class="text-end">
                      {{ formatM3(it.transportDocumentItemParcelVolume) }}
                    </td>
                    <td>{{ trip.tripCode }}</td>
                    <td>{{ it.transportDocumentCode || "-" }}</td>
                  </tr>
                </tbody>
              </table>
            </div>

            <div
              class="empty-state-inline"
              *ngIf="
                !parcelsLoading[trip.tripId] &&
                getParcelsForTrip(trip).length === 0
              "
            >
              <i class="fas fa-box me-2"></i> Nessun collo trovato per questo
              viaggio
            </div>
          </div>

          <!-- TAB 4: Punti Carico/Scarico -->
          <div *ngIf="isTabActive(trip, 'points')">
            <div
              class="table-scroll-wrapper"
              *ngIf="getSortedPoints(trip).length > 0; else noPointsTable"
            >
              <table class="manifest-table">
                <thead>
                  <tr>
                    <th></th>
                    <th>Azioni</th>
                    <th>Magazzino</th>
                    <th>Operazione</th>
                    <th>Stato</th>
                    <th>Creato il</th>
                    <th>Creato da</th>
                    <th>Caricato il</th>
                    <th>Arrivo autista il</th>
                    <th>Partenza navetta il</th>
                    <th>Arrivo navetta il</th>
                    <th>Scaricato il</th>
                    <th>Partenza/Arrivo dichiarato da</th>
                  </tr>
                </thead>
                <tbody>
                  <tr
                    *ngFor="
                      let point of getSortedPoints(trip);
                      trackBy: trackByPointId
                    "
                  >
                    <td class="text-start">
                      {{ point.tripPointSequence }}
                    </td>
                    <td class="text-start text-nowrap">
                      <button
                        type="button"
                        class="tp-action-btn"
                        (click)="openTripPointParcelsPopup(trip, point)"
                        matTooltip="Vedi colli abbinati a questo punto"
                        matTooltipPosition="above"
                      >
                        <i class="fas fa-boxes-stacked"></i>
                        <span>Colli</span>
                      </button>
                    <span *ngIf="canShowChangeDestination(trip, point)" class="tp-action-btn-wrapper ms-2"
                          matTooltip="Cambia la destinazione dei colli in partenza da questo punto"
                          matTooltipPosition="above">
                      <button type="button" class="tp-action-btn"
                              (click)="openChangeDestinationPopup(trip, point, $event)">
                        <i class="fas fa-route"></i>
                        <span>Cambia destinazione</span>
                      </button>
                    </span>
                    <span *ngIf="canShowCancelChangeDestination(trip, point)" class="tp-action-btn-wrapper ms-2"
                          matTooltip="Ripristina la destinazione originale dei colli in partenza da questo punto"
                          matTooltipPosition="above">
                      <button type="button" class="tp-action-btn"
                              (click)="openCancelChangeDestinationPopup(trip, point, $event)">
                        <i class="fas fa-rotate-left"></i>
                        <span>Annulla cambio destinazione</span>
                      </button>
                    </span>
                    </td>
                    <td class="text-start">
                      <span
                        [matTooltip]="
                          getPointTooltip(
                            point.tripPointWarehouseCode,
                            point.tripPointDealerCode
                          )
                        "
                        matTooltipPosition="above"
                      >
                        {{
                          getPointShortLabel(
                            point.tripPointWarehouseCode,
                            point.tripPointDealerCode
                          )
                        }}
                      </span>
                    </td>
                    <td class="text-start">
                      <span
                        class="operation-badge"
                        [ngClass]="getOperationClass(point)"
                      >
                        <i class="fas" [ngClass]="getPointIcon(point)"></i>
                        {{ getPointOperationLabel(point) | uppercase }}
                      </span>
                    </td>
                    <td class="text-start">
                      <div class="route-point-dates-points">
                        <div
                          *ngIf="
                            point.tripPointOperation === 'LOADING' ||
                            point.tripPointOperation === 'LOADING_UNLOADING'
                          "
                        >
                          <span
                            class="point-status-badge"
                            [style.color]="
                              getPointSubStatusColor(
                                point.tripPointLoadingStatus
                              )
                            "
                            [style.background]="
                              hexToRgba(
                                getPointSubStatusColor(
                                  point.tripPointLoadingStatus
                                ),
                                0.12
                              )
                            "
                          >
                            <i class="fas fa-arrow-up me-1"></i
                            >{{
                              getPointSubStatusLabel(
                                point.tripPointLoadingStatus
                              )
                            }}
                          </span>
                        </div>
                        <div
                          *ngIf="
                            point.tripPointOperation === 'UNLOADING' ||
                            point.tripPointOperation === 'LOADING_UNLOADING'
                          "
                        >
                          <span
                            class="point-status-badge"
                            [style.color]="
                              getPointSubStatusColor(
                                point.tripPointUnloadingStatus
                              )
                            "
                            [style.background]="
                              hexToRgba(
                                getPointSubStatusColor(
                                  point.tripPointUnloadingStatus
                                ),
                                0.12
                              )
                            "
                          >
                            <i class="fas fa-arrow-down me-1"></i
                            >{{
                              getPointSubStatusLabel(
                                point.tripPointUnloadingStatus
                              )
                            }}
                          </span>
                        </div>
                      </div>
                    </td>
                    <td class="text-start">
                      {{
                        point.tripPointCreatedAt
                          ? formatDateTime(point.tripPointCreatedAt)
                          : "-"
                      }}
                    </td>
                    <td class="text-start">
                      <i
                        *ngIf="point.tripPointCreatedBy === 'SPARE PARTS'"
                        class="fa-solid fa-mobile-screen-button"
                        matTooltip="Spare Parts (Palmare)"
                      >
                      </i>

                      <i
                        *ngIf="point.tripPointCreatedBy !== 'SPARE PARTS'"
                        class="fa-solid fa-desktop"
                        matTooltip="Atlas (PC)"
                      >
                      </i>
                    </td>
                    <!-- Caricato il -->
                    <td>
                      <div
                        *ngIf="isDeparturePoint(point); else noLoadedAt"
                        class="route-point-dates-points"
                        [class.text-done]="point.tripPointLoadedAt"
                      >
                        {{
                          point.tripPointLoadedAt
                            ? formatDateTime(point.tripPointLoadedAt)
                            : "In attesa carico"
                        }}
                      </div>
                      <ng-template #noLoadedAt
                        ><span class="text-muted">-</span></ng-template
                      >
                    </td>
                    <!-- Arrivo autista il (pronto a caricare): vettore trazionista, autista e sigillo -->
                    <td>
                      <ng-container
                        *ngIf="
                          isDeparturePoint(point) && canManageShuttle(point);
                          else noDriverReady
                        "
                      >
                        <!-- Arrivo autista gia' registrato: bottone grigio che riapre il popup in sola lettura -->
                        <button
                          *ngIf="getDriverReadyAt(point)"
                          type="button"
                          class="tp-action-btn tp-action-btn-done"
                          (click)="openDriverReadyPopup(trip, point, $event)"
                          matTooltip="Clicca per vedere il dettaglio"
                          matTooltipPosition="above"
                        >
                          <span class="shuttle-date-label">
                            {{ formatDateTime(getDriverReadyAt(point)) }}
                          </span>
                          <span
                            class="shuttle-lock-label"
                            *ngIf="point.tripPointDriverName"
                          >
                            <i class="fas fa-user me-1"></i
                            >{{ point.tripPointDriverName }}
                          </span>
                        </button>
                        <!-- Arrivo autista da inserire: possibile in qualsiasi momento prima della partenza -->
                        <button
                          *ngIf="canSetDriverReady(point)"
                          type="button"
                          class="tp-action-btn"
                          (click)="openDriverReadyPopup(trip, point, $event)"
                        >
                          <i class="fas fa-id-card"></i>
                          <span>Inserisci arrivo autista</span>
                        </button>
                        <span
                          *ngIf="
                            !getDriverReadyAt(point) &&
                            point.tripPointLoadingClosedAt
                          "
                          class="text-muted"
                          >-</span
                        >
                      </ng-container>
                      <ng-template #noDriverReady
                        ><span class="text-muted">-</span></ng-template
                      >
                    </td>
                    <!-- Partenza navetta il -->
                    <td>
                      <ng-container
                        *ngIf="
                          isDeparturePoint(point) && canManageShuttle(point);
                          else noShuttleDeparture
                        "
                      >
                        <!-- Partenza gia' registrata: bottone grigio che riapre il popup in sola lettura -->
                        <button
                          *ngIf="point.tripPointLoadingClosedAt"
                          type="button"
                          class="tp-action-btn tp-action-btn-done"
                          (click)="
                            openShuttleDatePopup(
                              trip,
                              point,
                              'departure',
                              $event
                            )
                          "
                          matTooltip="Clicca per vedere il dettaglio"
                          matTooltipPosition="above"
                        >
                          <span class="shuttle-date-label">
                            {{ formatDateTime(point.tripPointLoadingClosedAt) }}
                          </span>
                          <span
                            class="shuttle-lock-label"
                            *ngIf="point.tripPointLockCode"
                          >
                            <i class="fas fa-lock me-1"></i
                            >{{ point.tripPointLockCode }}
                          </span>
                        </button>
                        <span
                          *ngIf="!point.tripPointLoadingClosedAt"
                          class="tp-action-btn-wrapper"
                          [matTooltip]="
                            shuttleDepartureBlockedReason(trip, point)
                          "
                          [matTooltipDisabled]="
                            !isShuttleDepartureBlocked(trip, point)
                          "
                          matTooltipPosition="above"
                        >
                          <button
                            type="button"
                            class="tp-action-btn"
                            [disabled]="isShuttleDepartureBlocked(trip, point)"
                            (click)="
                              openShuttleDatePopup(
                                trip,
                                point,
                                'departure',
                                $event
                              )
                            "
                          >
                            <i class="fas fa-clock"></i>
                            <span>Inserisci data di partenza</span>
                          </button>
                        </span>
                      </ng-container>
                      <ng-template #noShuttleDeparture
                        ><span class="text-muted">-</span></ng-template
                      >
                    </td>
                    <!-- Arrivo navetta il -->
                    <td>
                      <ng-container
                        *ngIf="
                          isArrivalPoint(point) && canManageShuttle(point);
                          else noShuttleArrival
                        "
                      >
                        <div
                          *ngIf="point.tripPointArrivalAt"
                          class="shuttle-dates-row"
                        >
                          <span class="text-start">
                            {{ formatDateTime(point.tripPointArrivalAt) }}
                          </span>
                        </div>
                        <button
                          *ngIf="!point.tripPointArrivalAt"
                          type="button"
                          class="tp-action-btn"
                          (click)="
                            openShuttleDatePopup(trip, point, 'arrival', $event)
                          "
                        >
                          <i class="fas fa-clock"></i>
                          <span>Inserisci data di arrivo</span>
                        </button>
                      </ng-container>
                      <ng-template #noShuttleArrival
                        ><span class="text-muted">-</span></ng-template
                      >
                    </td>
                    <!-- Scaricato il -->
                    <td>
                      <div
                        *ngIf="isArrivalPoint(point); else noUnloadedAt"
                        class="route-point-dates-points"
                        [class.text-done]="point.tripPointUnloadedAt"
                      >
                        {{
                          point.tripPointUnloadedAt
                            ? formatDateTime(point.tripPointUnloadedAt)
                            : "In attesa scarico"
                        }}
                      </div>
                      <ng-template #noUnloadedAt
                        ><span class="text-muted">-</span></ng-template
                      >
                    </td>
                    <td>
                      <div class="text-start">
                        <div
                          *ngIf="
                            point.tripPointLoadingClosedByName &&
                            (point.tripPointOperation === 'LOADING' ||
                              point.tripPointOperation === 'LOADING_UNLOADING')
                          "
                          [class.text-done]="point.tripPointLoadedAt"
                        >
                          <i class="fas fa-arrow-up me-1"></i>
                          {{ point.tripPointLoadingClosedByName }}
                        </div>
                        <div
                          *ngIf="
                            point.tripPointArrivalByName &&
                            (point.tripPointOperation === 'UNLOADING' ||
                              point.tripPointOperation === 'LOADING_UNLOADING')
                          "
                          [class.text-done]="point.tripPointUnloadedAt"
                        >
                          <i class="fas fa-arrow-down me-1"></i>
                          {{ point.tripPointArrivalByName }}
                        </div>
                      </div>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>

            <ng-template #noPointsTable>
              <div class="empty-state-inline">
                <i class="fas fa-warehouse me-2"></i> Nessun punto di
                carico/scarico registrato per questo viaggio
              </div>
            </ng-template>
          </div>
        </div>

        <!-- invio bolle viaggio -->
        <div
          class="trip-card-footer"
          *ngIf="canSendDDT() && !isExternalTrip(trip)"
        >
          <div
            class="docs-info"
            *ngIf="
              isTripDocsSent(trip) ||
              isTripDocsPending(trip) ||
              hasTripDocsHistory(trip)
            "
          >
            <div class="close-info" *ngIf="isTripDocsSent(trip)">
              <i class="fas fa-circle-check me-1"></i>
              Bolle inviate il {{ formatDateTime(trip.tripDocsSentAt) }}
              {{ getUserNameSendRequestedBy(trip) }}
            </div>
            <div
              class="close-info close-info-pending"
              *ngIf="isTripDocsPending(trip)"
            >
              <i class="fas fa-hourglass-half me-1"></i>
              Invio in attesa (richiesto il
              {{ formatDateTime(trip.tripDocsSendRequestedAt) }}
              {{ getUserNameSendRequestedBy(trip) }})
            </div>
            <button
              type="button"
              class="btn-docs-history"
              *ngIf="hasTripDocsHistory(trip)"
              (click)="openDocsHistory(trip, $event)"
              matTooltip="Storico invio bolle"
              matTooltipPosition="above"
            >
              <i class="fas fa-clock-rotate-left"></i>
            </button>
          </div>

          <div class="flex-spacer"></div>

          <!-- Pulsante "Annulla invio": visibile SOLO nello stato "in attesa" (richiesto ma non ancora
             effettivamente inviato) -->
          <button
            type="button"
            class="btn btn-revert-docs-send me-2"
            *ngIf="isTripDocsPending(trip)"
            [disabled]="revertingDocsTrip[trip.tripId]"
            (click)="revertTripDocsSend(trip)"
            matTooltip="Annulla la richiesta di invio bolle"
          >
            <span *ngIf="!revertingDocsTrip[trip.tripId]">
              <i class="fas fa-rotate-left me-2"></i> Annulla invio
            </span>
            <span *ngIf="revertingDocsTrip[trip.tripId]">
              <i class="fas fa-spinner fa-spin me-2"></i> Annullamento...
            </span>
          </button>

          <button
            type="button"
            class="btn btn-close-trip"
            [ngClass]="{
              'btn-close-trip--pending': isTripDocsPending(trip),
              'btn-close-trip--sent': isTripDocsSent(trip),
            }"
            *ngIf="canSendTripDocs(trip) || sendingDocsTrip[trip.tripId]"
            [disabled]="sendingDocsTrip[trip.tripId]"
            (click)="openSendDocsConfirm(trip)"
          >
            <span *ngIf="!sendingDocsTrip[trip.tripId]">
              <i
                class="fas"
                [ngClass]="
                  isTripDocsSent(trip)
                    ? 'fa-circle-check'
                    : isTripDocsPending(trip)
                      ? 'fa-hourglass-half'
                      : 'fa-envelope-open'
                "
                style="margin-right: 0.5rem"
              ></i>
              {{
                isTripDocsSent(trip)
                  ? "Bolle già inviate"
                  : isTripDocsPending(trip)
                    ? "Invio in attesa"
                    : "Invio bolle viaggio"
              }}
            </span>
            <span *ngIf="sendingDocsTrip[trip.tripId]">
              <i class="fas fa-spinner fa-spin me-2"></i> Invio in corso...
            </span>
          </button>
        </div>
      </div>
    </div>

    <div class="trips-pagination-footer" *ngIf="totalTripsPages > 1">
      <button
        type="button"
        class="page-nav-btn"
        [disabled]="currentPage === 1"
        (click)="goToFirstTripsPage()"
        matTooltip="Prima pagina"
        matTooltipPosition="above"
      >
        <i class="fas fa-angles-left"></i>
      </button>

      <button
        type="button"
        class="page-nav-btn"
        [disabled]="currentPage === 1"
        (click)="goToPrevTripsPage()"
        matTooltip="Pagina precedente"
        matTooltipPosition="above"
      >
        <i class="fas fa-chevron-left"></i>
      </button>

      <div class="page-numbers">
        <ng-container *ngIf="tripsPageNumbers[0] > 1">
          <button
            type="button"
            class="page-number-btn"
            (click)="goToTripsPage(1)"
          >
            1
          </button>
          <span class="page-ellipsis" *ngIf="tripsPageNumbers[0] > 2">…</span>
        </ng-container>

        <button
          type="button"
          class="page-number-btn"
          *ngFor="let p of tripsPageNumbers"
          [class.active]="p === currentPage"
          (click)="goToTripsPage(p)"
        >
          {{ p }}
        </button>

        <ng-container
          *ngIf="
            tripsPageNumbers[tripsPageNumbers.length - 1] < totalTripsPages
          "
        >
          <span
            class="page-ellipsis"
            *ngIf="
              tripsPageNumbers[tripsPageNumbers.length - 1] <
              totalTripsPages - 1
            "
            >…</span
          >
          <button
            type="button"
            class="page-number-btn"
            (click)="goToTripsPage(totalTripsPages)"
          >
            {{ totalTripsPages }}
          </button>
        </ng-container>
      </div>

      <button
        type="button"
        class="page-nav-btn"
        [disabled]="currentPage === totalTripsPages"
        (click)="goToNextTripsPage()"
        matTooltip="Pagina successiva"
        matTooltipPosition="above"
      >
        <i class="fas fa-chevron-right"></i>
      </button>

      <button
        type="button"
        class="page-nav-btn"
        [disabled]="currentPage === totalTripsPages"
        (click)="goToLastTripsPage()"
        matTooltip="Ultima pagina"
        matTooltipPosition="above"
      >
        <i class="fas fa-angles-right"></i>
      </button>
    </div>
  </div>
</div>

<!-- Popup conferma chiusura viaggio -->
<div
  class="popup-overlay"
  *ngIf="showSendDocsConfirmFor"
  (click)="closeSendDocsConfirm()"
>
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h2 class="popup-title">
        <i class="fas fa-envelope-open me-2"></i>
        Invio bolle viaggio
      </h2>

      <button
        type="button"
        class="btn-close"
        (click)="closeSendDocsConfirm()"
        aria-label="Close"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <div class="alert alert-light border mb-3">
        Confermi l'invio delle bolle per il viaggio
        <b class="ms-1">{{ showSendDocsConfirmFor?.tripCode }}</b
        >?
      </div>

      <div class="mb-2 text-muted small">
        <i class="fas fa-info-circle me-1"></i>
        Una volta inviate, le bolle del viaggio non potranno essere inviate
        nuovamente da qui.
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end gap-2">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeSendDocsConfirm()"
        >
          Annulla
        </button>

        <button
          type="button"
          class="btn btn-close-trip"
          (click)="confirmSendTripDocs()"
        >
          <i class="fas fa-envelope-open me-2"></i> Conferma invio
        </button>
      </div>
    </div>
  </div>
</div>

<div class="popup-overlay" *ngIf="cancelChangeDestinationFor" (click)="closeCancelChangeDestinationPopup()">
  <div class="popup-content" (click)="$event.stopPropagation()">

    <div class="popup-header">
      <h2 class="popup-title">
        <i class="fas fa-rotate-left me-2"></i>
        Annulla cambio destinazione
      </h2>

      <button type="button" class="btn-close" (click)="closeCancelChangeDestinationPopup()" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <div class="alert alert-light border mb-3">
        Confermi l'annullamento del cambio destinazione verso
        <b class="ms-1">{{ getWarehouseName(cancelChangeDestinationFor.point.tripPointDestinationWarehouseCode) }}</b>
        per il viaggio <b>{{ cancelChangeDestinationFor.trip.tripCode }}</b>?
      </div>

      <div class="mb-2 text-muted small">
        <i class="fas fa-info-circle me-1"></i>
        I colli torneranno alla destinazione originale e verranno ripristinati vettore e autista precedenti.
      </div>

      <div class="alert alert-danger py-2 mb-0" *ngIf="cancelChangeDestinationError">
        {{ cancelChangeDestinationError }}
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end gap-2">
        <button type="button" class="btn btn-secondary" (click)="closeCancelChangeDestinationPopup()">
          Chiudi
        </button>

        <button type="button" class="btn btn-close-trip" [disabled]="cancelChangeDestinationSaving" (click)="confirmCancelChangeDestination()">
          <i class="fas fa-rotate-left me-2"></i> Conferma annullamento
        </button>
      </div>
    </div>

  </div>
</div>

<!-- Popup conferma invio bolle multiplo -->
<div
  class="popup-overlay"
  *ngIf="showBulkSendDocsConfirm"
  (click)="closeBulkSendDocsConfirm()"
>
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h2 class="popup-title">
        <i class="fas fa-envelope-open me-2"></i>
        Invio bolle viaggi selezionati
      </h2>

      <button
        type="button"
        class="btn-close"
        (click)="closeBulkSendDocsConfirm()"
        aria-label="Close"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <div class="alert alert-light border mb-3">
        Confermi l'invio delle bolle per
        <b class="ms-1">{{ selectableSelectedTrips.length }}</b>
        viaggi selezionati?
      </div>

      <div class="bulk-close-list mb-2" *ngIf="selectableSelectedTrips.length">
        <span
          class="bulk-close-chip"
          *ngFor="let t of selectableSelectedTrips"
          >{{ t.tripCode }}</span
        >
      </div>

      <div class="mb-2 text-muted small">
        <i class="fas fa-info-circle me-1"></i>
        Una volta inviate, le bolle dei viaggi selezionati non potranno essere
        inviate nuovamente da qui.
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end gap-2">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeBulkSendDocsConfirm()"
        >
          Annulla
        </button>

        <button
          type="button"
          class="btn btn-close-trip"
          (click)="confirmBulkSendTripDocs()"
        >
          <i class="fas fa-envelope-open me-2"></i> Conferma invio
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Popup data/ora di partenza/arrivo navetta per un punto di carico/scarico -->
<div
  class="popup-overlay"
  *ngIf="shuttleDatePopupFor"
  (click)="closeShuttleDatePopup()"
>
  <div
    class="popup-content popup-allow-overflow"
    (click)="$event.stopPropagation()"
  >
    <div class="popup-header">
      <h2 class="popup-title">
        <i class="fas fa-clock me-2"></i>
        {{ shuttlePopupTitle }}
      </h2>

      <button
        type="button"
        class="btn-close"
        (click)="closeShuttleDatePopup()"
        aria-label="Close"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body" *ngIf="shuttleStep === 'input'">
      <div class="mb-3 text-muted small">
        {{
          getDocumentPointLabel(
            shuttleDatePopupFor?.point?.tripPointWarehouseCode,
            shuttleDatePopupFor?.point?.tripPointDealerCode,
            "-"
          )
        }}
      </div>

      <div class="mb-3" *ngIf="shuttlePopupNeedsArrival">
        <label class="form-label">Data e ora di arrivo</label>
        <div
          class="d-flex gap-2"
          *ngIf="shuttleArrivalEditable; else arrivalAlreadySet"
        >
          <input
            type="date"
            class="form-control"
            [max]="todayDateStr"
            [(ngModel)]="shuttleArrivalDateStr"
          />
          <input
            type="time"
            class="form-control"
            [(ngModel)]="shuttleArrivalTimeStr"
          />
        </div>
        <ng-template #arrivalAlreadySet>
          <div class="shuttle-readonly-value">
            {{ formatDateTime(shuttleDatePopupFor?.point?.tripPointArrivalAt) }}
          </div>
        </ng-template>
      </div>

      <div class="mb-3" *ngIf="shuttlePopupNeedsDeparture">
        <label class="form-label">Data e ora di partenza</label>
        <div
          class="d-flex gap-2"
          *ngIf="shuttleDepartureEditable; else departureAlreadySet"
        >
          <input
            type="date"
            class="form-control"
            [attr.min]="shuttleDepartureMinDateStr"
            [max]="todayDateStr"
            [(ngModel)]="shuttleDepartureDateStr"
          />
          <input
            type="time"
            class="form-control"
            [(ngModel)]="shuttleDepartureTimeStr"
          />
        </div>
        <ng-template #departureAlreadySet>
          <div class="shuttle-readonly-value">
            {{
              formatDateTime(
                shuttleDatePopupFor?.point?.tripPointLoadingClosedAt
              )
            }}
          </div>
        </ng-template>
      </div>

      <!-- Sigillo registrato con l'arrivo autista: qui solo consultazione -->
      <div class="mb-3" *ngIf="shuttlePopupNeedsDeparture">
        <label class="form-label">Sigillo</label>
        <input
          type="text"
          class="form-control"
          [value]="shuttleLockCode || ''"
          [disabled]="true"
          placeholder="-"
        />
      </div>

      <div class="shuttle-view-only-note" *ngIf="shuttleViewOnly">
        <i class="fas fa-lock me-2"></i>Dati già registrati, non modificabili.
      </div>

      <div
        class="alert alert-danger py-2 small mb-0"
        *ngIf="shuttleValidationError"
      >
        {{ shuttleValidationError }}
      </div>
    </div>

    <div class="popup-body" *ngIf="shuttleStep === 'confirm'">
      <div class="shuttle-confirm-message">
        <i class="fas fa-circle-question me-2"></i>
        {{ shuttleConfirmMessage }}
      </div>
      <div
        class="alert alert-danger py-2 small mb-0 mt-3"
        *ngIf="shuttleValidationError"
      >
        {{ shuttleValidationError }}
      </div>
    </div>

    <div class="popup-footer">
      <div
        class="d-flex justify-content-end gap-2"
        *ngIf="shuttleStep === 'input' && shuttleViewOnly"
      >
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeShuttleDatePopup()"
        >
          Chiudi
        </button>
      </div>
      <div
        class="d-flex justify-content-end gap-2"
        *ngIf="shuttleStep === 'input' && !shuttleViewOnly"
      >
        <button
          type="button"
          class="btn btn-secondary"
          [disabled]="shuttleSaving"
          (click)="closeShuttleDatePopup()"
        >
          Annulla
        </button>
        <button
          type="button"
          class="btn btn-close-trip"
          [disabled]="shuttleSaving"
          (click)="goToShuttleConfirmStep()"
        >
          Avanti <i class="fas fa-arrow-right ms-2"></i>
        </button>
      </div>
      <div
        class="d-flex justify-content-end gap-2"
        *ngIf="shuttleStep === 'confirm'"
      >
        <button
          type="button"
          class="btn btn-secondary"
          [disabled]="shuttleSaving"
          (click)="backToShuttleInputStep()"
        >
          <i class="fas fa-arrow-left me-2"></i> Indietro
        </button>
        <button
          type="button"
          class="btn btn-close-trip"
          [disabled]="shuttleSaving"
          (click)="confirmShuttleDatePopup()"
        >
          <span *ngIf="!shuttleSaving"
            ><i class="fas fa-check me-2"></i> Conferma</span
          >
          <span *ngIf="shuttleSaving"
            ><i class="fas fa-spinner fa-spin me-2"></i> Salvataggio...</span
          >
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Popup arrivo autista (pronto a caricare) per un punto di carico: data/ora + dati di trazione -->
<div
  class="popup-overlay"
  *ngIf="driverReadyPopupFor"
  (click)="closeDriverReadyPopup()"
>
  <div
    class="popup-content popup-allow-overflow"
    (click)="$event.stopPropagation()"
  >
    <div class="popup-header">
      <h2 class="popup-title">
        <i class="fas fa-id-card me-2"></i>
        Arrivo autista
      </h2>

      <button
        type="button"
        class="btn-close"
        (click)="closeDriverReadyPopup()"
        aria-label="Close"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body" *ngIf="driverReadyStep === 'input'">
      <div class="mb-3 text-muted small">
        {{
          getDocumentPointLabel(
            driverReadyPopupFor?.point?.tripPointWarehouseCode,
            driverReadyPopupFor?.point?.tripPointDealerCode,
            "-"
          )
        }}
      </div>

      <div class="mb-3">
        <label class="form-label"
          >Data e ora arrivo autista (pronto a caricare)</label
        >
        <div
          class="d-flex gap-2"
          *ngIf="driverReadyEditable; else driverReadyAlreadySetTpl"
        >
          <input
            type="date"
            class="form-control"
            [max]="todayDateStr"
            [(ngModel)]="driverReadyDateStr"
          />
          <input
            type="time"
            class="form-control"
            [(ngModel)]="driverReadyTimeStr"
          />
        </div>
        <ng-template #driverReadyAlreadySetTpl>
          <div class="shuttle-readonly-value">
            {{ formatDateTime(getDriverReadyAt(driverReadyPopupFor?.point)) }}
          </div>
        </ng-template>
      </div>

      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="form-label">Vettore trazionista</label>
          <ng-select
            *ngIf="driverReadyEditable; else driverReadyCarrierReadOnly"
            class="filter-ng-select"
            [items]="carriers"
            bindLabel="carrierName"
            bindValue="carrierCode"
            [(ngModel)]="driverReadyCarrierCode"
            [searchFn]="searchCarrierFn"
            [clearable]="false"
            notFoundText="Nessun vettore trovato"
            placeholder="Seleziona vettore"
          >
            <ng-template ng-option-tmp let-item="item">
              <div class="carrier-option">
                <span class="carrier-option-name">{{ item.carrierName }}</span>
                <span class="carrier-option-code">{{ item.carrierCode }}</span>
              </div>
            </ng-template>
          </ng-select>
          <ng-template #driverReadyCarrierReadOnly>
            <input
              type="text"
              class="form-control"
              [value]="getCarrierName(driverReadyCarrierCode) || ''"
              [disabled]="true"
              placeholder="-"
            />
          </ng-template>
        </div>
        <!-- <div class="col-6">
          <label class="form-label">Targa motrice</label>
          <input type="text" class="form-control" [(ngModel)]="driverReadyTractorPlateNo" [disabled]="!driverReadyEditable" placeholder="Targa motrice">
        </div> -->
        <div class="col-6">
          <label class="form-label">Autista</label>
          <input
            type="text"
            class="form-control"
            [(ngModel)]="driverReadyDriverName"
            [disabled]="!driverReadyEditable"
            [placeholder]="driverReadyEditable ? 'Nome autista' : '-'"
          />
        </div>
        <div class="col-6">
          <label class="form-label"
            >Sigillo
            <span class="text-muted fw-normal" *ngIf="driverReadyEditable"
              >(facoltativo)</span
            ></label
          >
          <ng-container
            *ngIf="driverReadyEditable; else driverReadyLockReadOnly"
          >
            <div class="lock-code-input">
              <i class="fas fa-barcode lock-code-icon"></i>
              <input
                #lockCodeInput
                appScanInput
                type="text"
                class="form-control"
                [(ngModel)]="driverReadyLockCode"
                (scanDetected)="lockCodeScanned = $event"
                maxlength="100"
                autocomplete="off"
                spellcheck="false"
                placeholder="Scansiona o digita"
              />
            </div>
            <div class="lock-code-scanned" *ngIf="lockCodeScanned">
              <i class="fas fa-circle-check me-1"></i>Letto da scanner
            </div>
          </ng-container>
          <ng-template #driverReadyLockReadOnly>
            <input
              type="text"
              class="form-control"
              [value]="driverReadyLockCode || ''"
              [disabled]="true"
              placeholder="-"
            />
          </ng-template>
        </div>
      </div>

      <div class="shuttle-view-only-note" *ngIf="!driverReadyEditable">
        <i class="fas fa-lock me-2"></i>Dati già registrati, non modificabili.
      </div>

      <div
        class="alert alert-danger py-2 small mb-0"
        *ngIf="driverReadyValidationError"
      >
        {{ driverReadyValidationError }}
      </div>
    </div>

    <div class="popup-body" *ngIf="driverReadyStep === 'confirm'">
      <div class="shuttle-confirm-message">
        <i class="fas fa-circle-question me-2"></i>
        {{ driverReadyConfirmMessage }}
      </div>
      <div
        class="alert alert-danger py-2 small mb-0 mt-3"
        *ngIf="driverReadyValidationError"
      >
        {{ driverReadyValidationError }}
      </div>
    </div>

    <div class="popup-footer">
      <div
        class="d-flex justify-content-end gap-2"
        *ngIf="driverReadyStep === 'input' && !driverReadyEditable"
      >
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeDriverReadyPopup()"
        >
          Chiudi
        </button>
      </div>
      <div
        class="d-flex justify-content-end gap-2"
        *ngIf="driverReadyStep === 'input' && driverReadyEditable"
      >
        <button
          type="button"
          class="btn btn-secondary"
          [disabled]="driverReadySaving"
          (click)="closeDriverReadyPopup()"
        >
          Annulla
        </button>
        <button
          type="button"
          class="btn btn-close-trip"
          [disabled]="driverReadySaving"
          (click)="goToDriverReadyConfirmStep()"
        >
          Avanti <i class="fas fa-arrow-right ms-2"></i>
        </button>
      </div>
      <div
        class="d-flex justify-content-end gap-2"
        *ngIf="driverReadyStep === 'confirm'"
      >
        <button
          type="button"
          class="btn btn-secondary"
          [disabled]="driverReadySaving"
          (click)="backToDriverReadyInputStep()"
        >
          <i class="fas fa-arrow-left me-2"></i> Indietro
        </button>
        <button
          type="button"
          class="btn btn-close-trip"
          [disabled]="driverReadySaving"
          (click)="confirmDriverReadyPopup()"
        >
          <span *ngIf="!driverReadySaving"
            ><i class="fas fa-check me-2"></i> Conferma</span
          >
          <span *ngIf="driverReadySaving"
            ><i class="fas fa-spinner fa-spin me-2"></i> Salvataggio...</span
          >
        </button>
      </div>
    </div>
  </div>
</div>

<div class="popup-overlay" *ngIf="changeDestinationPopupFor" (click)="closeChangeDestinationPopup()">
  <div class="popup-content popup-allow-overflow" (click)="$event.stopPropagation()">

    <div class="popup-header">
      <h2 class="popup-title">
        <i class="fas fa-route me-2"></i>
        Cambia destinazione
      </h2>
      <button type="button" class="btn-close" (click)="closeChangeDestinationPopup()" aria-label="Close">
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body" *ngIf="changeDestinationStep === 'input'">
      <div class="mb-3 text-muted small">
        Partenza da {{ getDocumentPointLabel(changeDestinationPopupFor?.point?.tripPointWarehouseCode, changeDestinationPopupFor?.point?.tripPointDealerCode, '-') }},
        destinazione attuale {{ changeDestinationPopupFor ? getPointDestinationLabel(changeDestinationPopupFor.trip, changeDestinationPopupFor.point) : '-' }}
      </div>

      <div class="mb-3">
        <label class="form-label">Nuova destinazione <span class="text-danger">*</span></label>
        <ng-select
          class="filter-ng-select"
          [items]="changeDestinationWarehouses"
          bindValue="warehouseCode"
          [(ngModel)]="changeDestinationWarehouseCode"
          [searchable]="true"
          [searchFn]="searchWarehouseFn"
          [clearable]="false"
          notFoundText="Nessun magazzino trovato"
          placeholder="Seleziona magazzino">
          <ng-template ng-option-tmp let-item="item">
            <span class="status-option">
              <i class="fas fa-warehouse me-2"></i>
              <span>{{ item.warehouseName }} ({{ item.warehouseShortName }})</span>
            </span>
          </ng-template>
          <ng-template ng-label-tmp let-item="item">
            <span class="status-option">
              <i class="fas fa-warehouse me-2"></i>
              <span>{{ item.warehouseName }} ({{ item.warehouseShortName }})</span>
            </span>
          </ng-template>
        </ng-select>
      </div>

      <div class="row mb-3">
        <div class="col-12 mb-3">
          <label class="form-label">Vettore trazionista <span class="text-danger">*</span></label>
          <ng-select
            class="filter-ng-select"
            [items]="carriers"
            bindLabel="carrierName"
            bindValue="carrierCode"
            [(ngModel)]="changeDestinationCarrierCode"
            [searchFn]="searchCarrierFn"
            [clearable]="false"
            notFoundText="Nessun vettore trovato"
            placeholder="Seleziona vettore">
            <ng-template ng-option-tmp let-item="item">
              <div class="carrier-option">
                <span class="carrier-option-name">{{ item.carrierName }}</span>
                <span class="carrier-option-code">{{ item.carrierCode }}</span>
              </div>
            </ng-template>
          </ng-select>
        </div>
        <div class="col-6">
          <label class="form-label">Autista <span class="text-danger">*</span></label>
          <input type="text" class="form-control" [(ngModel)]="changeDestinationDriverName" placeholder="Nome autista">
        </div>
      </div>

      <div class="alert alert-danger py-2 small mb-0" *ngIf="changeDestinationError">
        {{ changeDestinationError }}
      </div>
    </div>

    <div class="popup-body" *ngIf="changeDestinationStep === 'confirm'">
      <div class="shuttle-confirm-message">
        <i class="fas fa-circle-question me-2"></i>
        <span>
          Confermi il cambio di destinazione dei colli in partenza da
          {{ getDocumentPointLabel(changeDestinationPopupFor?.point?.tripPointWarehouseCode, changeDestinationPopupFor?.point?.tripPointDealerCode, '-') }}
          verso <b>{{ changeDestinationWarehouseName }}</b>? I colli passeranno in transito da questo magazzino prima di proseguire verso la destinazione attuale.
        </span>
      </div>
      <div class="alert alert-danger py-2 small mb-0 mt-3" *ngIf="changeDestinationError">
        {{ changeDestinationError }}
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end gap-2" *ngIf="changeDestinationStep === 'input'">
        <button type="button" class="btn btn-secondary" (click)="closeChangeDestinationPopup()">
          Annulla
        </button>
        <button type="button" class="btn btn-close-trip"
                [disabled]="!changeDestinationWarehouseCode || !changeDestinationCarrierCode || !changeDestinationDriverName?.trim()"
                (click)="goToChangeDestinationConfirmStep()">
          Avanti <i class="fas fa-arrow-right ms-2"></i>
        </button>
      </div>
      <div class="d-flex justify-content-end gap-2" *ngIf="changeDestinationStep === 'confirm'">
        <button type="button" class="btn btn-secondary" [disabled]="changeDestinationSaving" (click)="backToChangeDestinationInputStep()">
          <i class="fas fa-arrow-left me-2"></i> Indietro
        </button>
        <button type="button" class="btn btn-close-trip" [disabled]="changeDestinationSaving" (click)="confirmChangeDestination()">
          <span *ngIf="!changeDestinationSaving"><i class="fas fa-check me-2"></i> Conferma</span>
          <span *ngIf="changeDestinationSaving"><i class="fas fa-spinner fa-spin me-2"></i> Salvataggio...</span>
        </button>
      </div>
    </div>

  </div>
</div>

<!-- Popup modifica testata viaggio (vettore + targa rimorchio), possibile solo fino alla prima partenza -->
<div
  class="popup-overlay"
  *ngIf="tripHeaderPopupFor"
  (click)="closeTripHeaderPopup()"
>
  <div
    class="popup-content popup-allow-overflow"
    (click)="$event.stopPropagation()"
  >
    <div class="popup-header">
      <h2 class="popup-title">
        <i class="fas fa-pen me-2"></i>
        Modifica viaggio {{ tripHeaderPopupFor?.tripCode }}
      </h2>
      <button
        type="button"
        class="btn-close"
        (click)="closeTripHeaderPopup()"
        aria-label="Close"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <div class="mb-3 text-muted small">
        Vettore e targa rimorchio sono obbligatori e modificabili solo fino alla
        prima data di partenza da un punto di carico.
      </div>

      <div class="mb-3">
        <label class="form-label"
          >Vettore <span class="text-danger">*</span></label
        >
        <ng-select
          class="filter-ng-select"
          [items]="carriers"
          bindLabel="carrierName"
          bindValue="carrierCode"
          [(ngModel)]="tripHeaderCarrierCode"
          [searchFn]="searchCarrierFn"
          [clearable]="false"
          notFoundText="Nessun vettore trovato"
          placeholder="Seleziona vettore"
        >
          <ng-template ng-option-tmp let-item="item">
            <div class="carrier-option">
              <span class="carrier-option-name">{{ item.carrierName }}</span>
              <span class="carrier-option-code">{{ item.carrierCode }}</span>
            </div>
          </ng-template>
        </ng-select>
      </div>

      <div class="mb-3">
        <label class="form-label"
          >Targa rimorchio <span class="text-danger">*</span></label
        >
        <input
          type="text"
          class="form-control filter-like-input"
          [(ngModel)]="tripHeaderPlateNo"
          placeholder="Targa rimorchio"
          (keyup.enter)="saveTripHeader()"
        />
      </div>

      <div class="alert alert-danger py-2 small mb-0" *ngIf="tripHeaderError">
        {{ tripHeaderError }}
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end gap-2">
        <button
          type="button"
          class="btn btn-secondary"
          [disabled]="tripHeaderSaving"
          (click)="closeTripHeaderPopup()"
        >
          Annulla
        </button>
        <button
          type="button"
          class="btn btn-close-trip"
          [disabled]="
            tripHeaderSaving ||
            !tripHeaderCarrierCode ||
            !tripHeaderPlateNo?.trim()
          "
          (click)="saveTripHeader()"
        >
          <span *ngIf="!tripHeaderSaving"
            ><i class="fas fa-check me-2"></i> Salva</span
          >
          <span *ngIf="tripHeaderSaving"
            ><i class="fas fa-spinner fa-spin me-2"></i> Salvataggio...</span
          >
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Popup dettaglio partenza da un punto di carico (click sul route-node nel tab Percorso) -->
<div
  class="popup-overlay"
  *ngIf="routeDetailPopupFor"
  (click)="closeRouteDetailPopup()"
>
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h2 class="popup-title">
        <i class="fas fa-warehouse me-2"></i>
        {{
          getDocumentPointLabel(
            routeDetailPopupFor?.point?.tripPointWarehouseCode,
            routeDetailPopupFor?.point?.tripPointDealerCode,
            "-"
          )
        }}
      </h2>
      <button
        type="button"
        class="btn-close"
        (click)="closeRouteDetailPopup()"
        aria-label="Close"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <div class="detail-section-title-trip">
        <i class="fas fa-truck me-2"></i>Viaggio
      </div>
      <div class="detail-grid mb-3">
        <div class="detail-item">
          <span class="detail-label">Vettore</span>
          <span class="detail-value">{{
            getCarrierName(routeDetailPopupFor?.trip?.tripCarrierCode) || "-"
          }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Targa rimorchio</span>
          <span class="detail-value">{{
            routeDetailPopupFor?.trip?.tripPlateNo || "-"
          }}</span>
        </div>
      </div>

      <div class="detail-section-title">
        <i class="fas fa-arrow-up me-2"></i>Carico
      </div>
      <div class="detail-grid">
        <div class="detail-item">
          <span class="detail-label">Arrivo autista (pronto a caricare)</span>
          <span class="detail-value">
            {{
              getDriverReadyAt(routeDetailPopupFor?.point)
                ? formatDateTime(getDriverReadyAt(routeDetailPopupFor?.point))
                : "Arrivo autista non ancora registrato"
            }}
          </span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Data e ora di partenza</span>
          <span class="detail-value">
            {{
              routeDetailPopupFor?.point?.tripPointLoadingClosedAt
                ? formatDateTime(
                    routeDetailPopupFor?.point?.tripPointLoadingClosedAt
                  )
                : "Partenza non ancora registrata"
            }}
          </span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Vettore trazionista</span>
          <span class="detail-value">{{
            getCarrierName(routeDetailPopupFor?.point?.tripPointCarrierCode) ||
              "-"
          }}</span>
        </div>
        <!-- <div class="detail-item">
          <span class="detail-label">Targa motrice</span>
          <span class="detail-value">{{ routeDetailPopupFor?.point?.tripPointTractorPlateNo || '-' }}</span>
        </div> -->
        <div class="detail-item">
          <span class="detail-label">Autista</span>
          <span class="detail-value">{{
            routeDetailPopupFor?.point?.tripPointDriverName || "-"
          }}</span>
        </div>
        <div class="detail-item">
          <span class="detail-label">Sigillo</span>
          <span class="detail-value">{{
            routeDetailPopupFor?.point?.tripPointLockCode || "-"
          }}</span>
        </div>
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeRouteDetailPopup()"
        >
          Chiudi
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Popup "Unisci a un altro viaggio" (sposta un borderò PREPARED su un viaggio diverso) -->
<div
  class="popup-overlay"
  *ngIf="mergeTripPopupFor"
  (click)="closeMergeTripPopup()"
>
  <div
    class="popup-content merge-trip-popup"
    (click)="$event.stopPropagation()"
  >
    <div class="popup-header">
      <h2 class="popup-title">
        <i class="fas fa-link me-2"></i>
        Unisci a un altro viaggio
      </h2>

      <button
        type="button"
        class="btn-close"
        (click)="closeMergeTripPopup()"
        aria-label="Close"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <div class="mb-3 text-muted small">
        Borderò <b>{{ mergeTripPopupFor?.loadingListCode }}</b>
      </div>

      <!-- STEP 1: inserimento codice viaggio / documento di trasporto -->
      <div *ngIf="mergeTripPopupStep === 'scan'">
        <label class="form-label"
          >Codice viaggio o documento di trasporto</label
        >
        <div class="filter-input-wrapper mb-2">
          <i class="fas fa-barcode filter-icon"></i>
          <input
            type="text"
            class="filter-input"
            [(ngModel)]="mergeTripScannedCode"
            (keyup.enter)="resolveMergeTripScannedCode()"
            placeholder="Es. VIA0000123 oppure DOC0000456"
            autofocus
          />
        </div>

        <div
          class="alert alert-danger py-2 px-3 small mb-0"
          *ngIf="mergeTripResolveError"
        >
          <i class="fas fa-exclamation-triangle me-2"></i
          >{{ mergeTripResolveError }}
        </div>
      </div>

      <!-- STEP 2: conferma con le informazioni del viaggio trovato -->
      <div
        *ngIf="
          mergeTripPopupStep === 'confirm' && mergeTripResolvedTrip as trip
        "
      >
        <div class="merge-trip-summary">
          <div class="merge-trip-summary-header">
            <i class="fas fa-truck me-2"></i>
            <span class="merge-trip-code">{{ trip.tripCode }}</span>
            <span
              class="merge-trip-status"
              *ngIf="trip.tripStatus"
              [style.color]="getStatusMeta(trip.tripStatus).color"
              [style.background]="
                hexToRgba(getStatusMeta(trip.tripStatus).color, 0.12)
              "
            >
              {{ getStatusMeta(trip.tripStatus).label }}
            </span>
          </div>

          <div class="merge-trip-info-grid">
            <div
              class="merge-trip-info-item"
              *ngIf="trip.tripCarrierName || trip.tripCarrierCode"
            >
              <i class="fas fa-building"></i>
              <span>{{ trip.tripCarrierName || trip.tripCarrierCode }}</span>
            </div>
            <div class="merge-trip-info-item" *ngIf="trip.tripPlateNo">
              <i class="fas fa-id-card"></i>
              <span>{{ trip.tripPlateNo }}</span>
            </div>
            <div
              class="merge-trip-info-item"
              *ngIf="trip.tripWarehouseFromName || trip.tripWarehouseFromCode"
            >
              <i class="fas fa-warehouse"></i>
              <span
                >Partenza:
                {{
                  trip.tripWarehouseFromName || trip.tripWarehouseFromCode
                }}</span
              >
            </div>
            <div
              class="merge-trip-info-item"
              *ngIf="trip.tripParcelsCount != null"
            >
              <i class="fas fa-box"></i>
              <span>{{ trip.tripParcelsCount }} colli</span>
            </div>
            <div
              class="merge-trip-info-item"
              *ngIf="trip.tripParcelsWeight != null"
            >
              <i class="fas fa-weight-hanging"></i>
              <span>{{ trip.tripParcelsWeight | number: "1.0-2" }} kg</span>
            </div>
            <div
              class="merge-trip-info-item"
              *ngIf="trip.tripParcelsVolume != null"
            >
              <i class="fas fa-cube"></i>
              <span>{{ trip.tripParcelsVolume | number: "1.0-3" }} m³</span>
            </div>
            <div
              class="merge-trip-info-item"
              *ngIf="trip.loadingListCodes?.length"
            >
              <i class="fas fa-clipboard-list"></i>
              <span
                >{{ trip.loadingListCodes?.length }} borderò già collegati</span
              >
            </div>
          </div>

          <div class="merge-trip-route" *ngIf="trip.tripRoutePoints?.length">
            <div class="merge-trip-route-label">Percorso</div>
            <div class="merge-trip-route-points">
              <span
                class="merge-trip-route-point"
                *ngFor="let p of trip.tripRoutePoints"
                [class.done]="isMergeRoutePointDone(p)"
              >
                <i class="fas fa-map-marker-alt me-1"></i>{{ p.tripPointName }}
                <span
                  class="operation-badge ms-2"
                  [ngClass]="getOperationClass(p)"
                  *ngIf="p.tripPointOperation"
                >
                  <i class="fas" [ngClass]="getPointIcon(p)"></i>
                  {{ getPointOperationLabel(p) }}
                </span>
              </span>
            </div>
          </div>
        </div>

        <div class="mt-3 mb-2">
          Confermi lo spostamento del borderò
          <b>{{ mergeTripPopupFor?.loadingListCode }}</b> su questo viaggio? Il
          borderò verrà scollegato dal viaggio in cui si trova attualmente.
        </div>

        <div
          class="alert alert-danger py-2 px-3 small mb-0"
          *ngIf="mergeTripConfirmError"
        >
          <i class="fas fa-exclamation-triangle me-2"></i
          >{{ mergeTripConfirmError }}
        </div>
      </div>
    </div>

    <div class="popup-footer">
      <div
        class="d-flex justify-content-end gap-2"
        *ngIf="mergeTripPopupStep === 'scan'"
      >
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeMergeTripPopup()"
        >
          Annulla
        </button>
        <button
          type="button"
          class="btn btn-close-trip"
          [disabled]="!mergeTripScannedCode.trim() || mergeTripResolving"
          (click)="resolveMergeTripScannedCode()"
        >
          <span *ngIf="!mergeTripResolving"
            ><i class="fas fa-search me-2"></i> Cerca viaggio</span
          >
          <span *ngIf="mergeTripResolving"
            ><i class="fas fa-spinner fa-spin me-2"></i> Ricerca in
            corso...</span
          >
        </button>
      </div>

      <div
        class="d-flex justify-content-end gap-2"
        *ngIf="mergeTripPopupStep === 'confirm'"
      >
        <button
          type="button"
          class="btn btn-secondary"
          [disabled]="mergeTripConfirming"
          (click)="backToMergeTripScanStep()"
        >
          <i class="fas fa-arrow-left me-2"></i> Indietro
        </button>
        <button
          type="button"
          class="btn btn-close-trip"
          [disabled]="mergeTripConfirming"
          (click)="confirmMergeTrip()"
        >
          <span *ngIf="!mergeTripConfirming"
            ><i class="fas fa-check me-2"></i> Conferma unione</span
          >
          <span *ngIf="mergeTripConfirming"
            ><i class="fas fa-spinner fa-spin me-2"></i> Spostamento in
            corso...</span
          >
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Popup colli abbinati a un punto di carico/scarico -->
<div
  class="popup-overlay"
  *ngIf="selectedTripPoint"
  (click)="closeTripPointParcelsPopup()"
>
  <div class="popup-content tpp-popup" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h2 class="popup-title">
        <span class="tpp-title-text">
          <i class="fas fa-boxes-stacked me-2"></i>
          Colli
        </span>

        <span
          class="operation-badge"
          [ngClass]="getOperationClass(selectedTripPoint)"
        >
          <i class="fas" [ngClass]="getPointIcon(selectedTripPoint)"></i>
          PUNTO {{ getPointOperationLabel(selectedTripPoint) | uppercase }}
        </span>
      </h2>

      <button
        type="button"
        class="btn-close"
        (click)="closeTripPointParcelsPopup()"
        aria-label="Close"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body step-2">
      <!-- Riepilogo -->
      <div class="items-summary-card mb-3">
        <div
          class="d-flex justify-content-between align-items-center flex-wrap gap-2"
        >
          <div>
            <div class="summary-title">
              <i class="fas fa-warehouse me-2"></i>
              {{
                getDocumentPointLabel(
                  selectedTripPoint?.tripPointWarehouseCode,
                  selectedTripPoint?.tripPointDealerCode,
                  "-"
                )
              }}
              <span
                class="tpp-sequence-badge ms-2"
                *ngIf="selectedTripPoint?.tripPointSequence"
              >
                Tappa {{ selectedTripPoint?.tripPointSequence }}
              </span>
            </div>
            <div class="summary-sub text-muted">
              Viaggio <b>{{ selectedTripPointTrip?.tripCode }}</b>
            </div>
          </div>

          <div class="items-counter-badge">
            {{ tripPointParcels.length }} coll{{
              tripPointParcels.length === 1 ? "o" : "i"
            }}
          </div>
        </div>

        <div class="summary-one-line mt-2">
          <span class="summary-item">
            <i class="fas fa-weight-hanging text-muted"></i>
            <b>{{ formatKg(tripPointParcelsTotalWeight) }}</b>
            <span class="summary-breakdown" *ngIf="tripPointParcelsHasBothTabs">
              (Carico: {{ formatKg(tripPointParcelsLoadWeight) }} • Scarico:
              {{ formatKg(tripPointParcelsUnloadWeight) }})
            </span>
          </span>
          <span class="dot">•</span>
          <span class="summary-item">
            <i class="fas fa-cube text-muted"></i>
            <b>{{ formatM3(tripPointParcelsTotalVolume) }}</b>
            <span class="summary-breakdown" *ngIf="tripPointParcelsHasBothTabs">
              (Carico: {{ formatM3(tripPointParcelsLoadVolume) }} • Scarico:
              {{ formatM3(tripPointParcelsUnloadVolume) }})
            </span>
          </span>
          <ng-container *ngIf="tripPointParcelsUrgentCount > 0">
            <span class="summary-item summary-item-urgent-right">
              <i class="fas fa-triangle-exclamation" style="color: #dc3545"></i>
              <b style="color: #dc3545"
                >{{ tripPointParcelsUrgentCount }} urgent{{
                  tripPointParcelsUrgentCount === 1 ? "e" : "i"
                }}</b
              >
            </span>
          </ng-container>
        </div>
      </div>

      <!-- Tab Carico/Scarico -->
      <div
        class="tpp-tabs mb-3"
        *ngIf="
          tripPointParcelsToLoad.length > 0 ||
          tripPointParcelsToUnload.length > 0
        "
      >
        <button
          type="button"
          class="tpp-tab-btn"
          *ngIf="tripPointParcelsToLoad.length > 0"
          [class.active]="tripPointParcelsTab === 'load'"
          (click)="selectTripPointParcelsTab('load')"
        >
          <i class="fas fa-arrow-up me-1"></i> Carico
          <span class="tab-count">{{ tripPointParcelsToLoad.length }}</span>
        </button>
        <button
          type="button"
          class="tpp-tab-btn"
          *ngIf="tripPointParcelsToUnload.length > 0"
          [class.active]="tripPointParcelsTab === 'unload'"
          (click)="selectTripPointParcelsTab('unload')"
        >
          <i class="fas fa-arrow-down me-1"></i> Scarico
          <span class="tab-count">{{ tripPointParcelsToUnload.length }}</span>
        </button>
      </div>

      <!-- Ricerca + filtro urgenti -->
      <div
        class="d-flex justify-content-end align-items-center flex-wrap gap-2 mb-3"
      >
        <span
          class="urgency-badge-filter"
          [ngClass]="tripPointParcelsOnlyUrgent ? 'active' : 'inactive'"
          (click)="toggleTripPointParcelsUrgentFilter()"
        >
          <span class="urgency-radio"
            ><span class="urgency-radio-ui"></span
          ></span>
          <span class="urgency-label">Solo urgenti</span>
        </span>
        <div class="barcode-search">
          <i class="fas fa-magnifying-glass search-ico"></i>
          <input
            type="text"
            class="form-control barcode-input"
            placeholder="Cerca per codice o barcode..."
            [(ngModel)]="tripPointParcelsSearch"
          />
          <a
            href="javascript:void(0)"
            class="clear-btn"
            *ngIf="tripPointParcelsSearch"
            (click)="clearTripPointParcelsSearch()"
          >
            <i class="fas fa-times"></i>
          </a>
        </div>
      </div>

      <!-- Lista colli -->
      <div class="items-step-wrap" [class.is-loading]="tripPointParcelsLoading">
        <div class="items-loading-overlay" *ngIf="tripPointParcelsLoading">
          <div class="items-loading-card">
            <div class="spinner-border text-primary mb-2" role="status"></div>
            <span class="text-muted small">Caricamento colli...</span>
          </div>
        </div>

        <div class="items-list-scroll">
          <div class="items-list" *ngIf="filteredTripPointParcels.length > 0">
            <div
              class="item-row"
              *ngFor="
                let p of filteredTripPointParcels;
                trackBy: trackByParcelRow
              "
            >
              <div class="item-main d-flex justify-content-between w-100">
                <div class="item-left w-100">
                  <div class="item-top-row d-flex align-items-center">
                    <span class="parcel-code">
                      {{ p.parcelCode || "-" }}
                    </span>
                  </div>

                  <div class="item-extra-row text-muted mb-0 mt-1 ms-2">
                    <span class="extra-info"
                      ><i class="fas fa-weight-hanging me-1"></i
                      >{{ formatKg(p.parcelWeight) }}</span
                    >
                    <span class="extra-info"
                      ><i class="fas fa-cube me-1"></i
                      >{{ formatM3(p.parcelVolume) }}</span
                    >
                  </div>
                </div>

                <div class="item-right">
                  <span *ngIf="p.parcelUrgent" class="urgency-badge-item ms-2">
                    URGENTE
                  </span>

                  <span
                    class="badge status-badge text-center"
                    [class.validated]="getTripPointParcelStatusMeta(p).done"
                    [class.pending]="!getTripPointParcelStatusMeta(p).done"
                  >
                    <i
                      class="fas"
                      [class.fa-check]="getTripPointParcelStatusMeta(p).done"
                      [class.fa-circle]="!getTripPointParcelStatusMeta(p).done"
                    ></i>
                    {{ getTripPointParcelStatusMeta(p).label }}
                  </span>
                </div>
              </div>
            </div>
          </div>

          <div
            class="empty-state-inline"
            *ngIf="
              !tripPointParcelsLoading && filteredTripPointParcels.length === 0
            "
          >
            <i class="fas fa-box me-2"></i> Nessun collo abbinato a questo punto
          </div>
        </div>
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeTripPointParcelsPopup()"
        >
          Chiudi
        </button>
      </div>
    </div>
  </div>
</div>
<!-- Popup colli del documento di trasporto -->
<div
  class="popup-overlay"
  *ngIf="selectedTransportDocument"
  (click)="closeTransportDocumentParcelsPopup()"
>
  <div
    class="popup-content doc-parcels-popup"
    (click)="$event.stopPropagation()"
  >
    <div class="popup-header">
      <h2 class="popup-title">
        <i class="fas fa-box me-2"></i>
        Colli — Documento {{ selectedTransportDocument?.transportDocumentCode }}
      </h2>

      <button
        type="button"
        class="btn-close"
        (click)="closeTransportDocumentParcelsPopup()"
        aria-label="Close"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <div
        class="text-center py-3"
        *ngIf="
          selectedTransportDocumentTrip &&
          parcelsLoading[selectedTransportDocumentTrip.tripId]
        "
      >
        <div
          class="spinner-border spinner-border-sm text-primary"
          role="status"
        ></div>
        <span class="ms-2 text-muted">Caricamento colli...</span>
      </div>

      <table
        class="manifest-table"
        *ngIf="
          selectedTransportDocumentTrip &&
          !parcelsLoading[selectedTransportDocumentTrip.tripId] &&
          getTransportDocumentParcels().length > 0
        "
      >
        <thead>
          <tr>
            <th>Codice collo</th>
            <th>Barcode</th>
            <th class="text-end">Peso</th>
            <th class="text-end">Volume</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let item of getTransportDocumentParcels()">
            <td class="fw-semibold">
              {{ item.transportDocumentItemParcelCode || "-" }}
            </td>
            <td>{{ item.transportDocumentItemBarcode || "-" }}</td>
            <td class="text-end">
              {{ formatKg(item.transportDocumentItemParcelWeight) }}
            </td>
            <td class="text-end">
              {{ formatM3(item.transportDocumentItemParcelVolume) }}
            </td>
          </tr>
        </tbody>
      </table>

      <div
        class="empty-state-inline"
        *ngIf="
          selectedTransportDocumentTrip &&
          !parcelsLoading[selectedTransportDocumentTrip.tripId] &&
          getTransportDocumentParcels().length === 0
        "
      >
        <i class="fas fa-box me-2"></i> Nessun collo trovato per questo
        documento
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeTransportDocumentParcelsPopup()"
        >
          Chiudi
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Popup "Collega borderò esistenti" al viaggio -->
<div
  class="popup-overlay"
  *ngIf="linkLoadingListsPopupOpen"
  (click)="closeLinkLoadingListsPopup()"
>
  <div class="popup-content link-ll-popup" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h2 class="popup-title">
        <i class="fas fa-right-left me-1"></i>
        <ng-container *ngIf="linkLoadingListsPopupStep === 'select'">
          Collega borderò al viaggio
          <b>{{ linkLoadingListsPopupTrip?.tripCode }}</b>
        </ng-container>
        <ng-container *ngIf="linkLoadingListsPopupStep === 'confirm'">
          Conferma collegamento al viaggio
          <b>{{ linkLoadingListsPopupTrip?.tripCode }}</b>
        </ng-container>
      </h2>

      <button
        type="button"
        class="btn-close"
        (click)="closeLinkLoadingListsPopup()"
        aria-label="Close"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <!-- STEP 1: selezione borderò -->
    <div
      class="popup-body link-ll-body"
      *ngIf="linkLoadingListsPopupStep === 'select'"
    >
      <!-- Toolbar fissa: filtro, conteggi, seleziona/deseleziona tutto -->
      <div class="link-ll-toolbar">
        <div
          class="d-flex justify-content-end align-items-center flex-wrap gap-2"
        >
          <div class="d-flex gap-2">
            <button
              type="button"
              class="btn btn-outline-secondary btn-sm"
              [disabled]="filteredLoadingListsToLink.length === 0"
              (click)="selectAllLoadingListsToLink()"
            >
              Seleziona tutto
            </button>
            <button
              type="button"
              class="btn btn-outline-secondary btn-sm"
              [disabled]="selectedLoadingListsToLinkCount === 0"
              (click)="deselectAllLoadingListsToLink()"
            >
              Deseleziona tutto
            </button>
          </div>
        </div>

        <div class="link-ll-filter">
          <div class="link-ll-filter-input">
            <i class="fas fa-search"></i>
            <input
              type="text"
              class="form-control form-control-sm"
              placeholder="Filtra per data, codice borderò, codice viaggio o magazzino..."
              [(ngModel)]="linkLoadingListsFilterText"
            />
            <button
              type="button"
              class="link-ll-filter-clear"
              *ngIf="linkLoadingListsFilterText"
              (click)="linkLoadingListsFilterText = ''"
              aria-label="Cancella filtro"
            >
              <i class="fas fa-times"></i>
            </button>
          </div>
        </div>

        <div
          class="link-ll-total-summary"
          *ngIf="
            !linkLoadingListsLoading && availableLoadingListsToLink.length > 0
          "
        >
          <b>{{ filteredLoadingListsToLink.length }}</b> border{{
            filteredLoadingListsToLink.length === 1 ? "ò" : "ò"
          }}
          trovat{{ filteredLoadingListsToLink.length === 1 ? "o" : "i" }}
          <ng-container *ngIf="linkLoadingListsFilterText">
            su <b>{{ availableLoadingListsToLink.length }}</b> totali
          </ng-container>
        </div>
      </div>

      <!-- Solo questa parte scrolla -->
      <div class="link-ll-scroll">
        <div class="text-center py-4" *ngIf="linkLoadingListsLoading">
          <div
            class="spinner-border spinner-border-sm text-primary"
            role="status"
          ></div>
          <span class="ms-2 text-muted">Ricerca borderò disponibili...</span>
        </div>

        <div
          class="link-ll-list"
          *ngIf="
            !linkLoadingListsLoading && filteredLoadingListsToLink.length > 0
          "
        >
          <div
            class="link-ll-card"
            *ngFor="let ll of filteredLoadingListsToLink"
            [class.selected]="isLoadingListSelectedToLink(ll)"
            (click)="toggleLoadingListSelection(ll)"
          >
            <div class="link-ll-check">
              <input
                type="checkbox"
                [checked]="isLoadingListSelectedToLink(ll)"
                (click)="$event.stopPropagation()"
                (change)="toggleLoadingListSelection(ll)"
              />
            </div>

            <div class="link-ll-main">
              <div
                class="d-flex justify-content-between align-items-center flex-wrap gap-2"
              >
                <div
                  class="gap-2 d-flex justify-content-between align-items-center flex-wrap"
                >
                  <span class="link-ll-code">
                    <i class="fas fa-clipboard-list me-2"></i
                    >{{ ll.loadingListCode }}
                  </span>
                  <div class="link-ll-meta">
                    <span class="link-ll-meta-item">
                      <i class="fas fa-calendar"></i>
                      {{ formatDateTime(ll.loadingListCreatedAt) }}
                    </span>
                  </div>
                </div>

                <span
                  class="status-chip small"
                  [style.color]="
                    getLoadingListStatusStyle(ll.loadingListStatus).color
                  "
                  [style.background]="
                    getLoadingListStatusStyle(ll.loadingListStatus)
                      .backgroundColor
                  "
                >
                  {{ getLoadingListStatusLabel(ll.loadingListStatus) }}
                </span>

                <span class="link-trip-badge" *ngIf="ll.loadingListTripCode">
                  <i class="fas fa-link"></i>
                  {{ ll.loadingListTripCode }}
                </span>
              </div>

              <div class="link-ll-meta mt-1">
                <span
                  class="link-ll-meta-item"
                  [matTooltip]="getWarehouseName(ll.loadingListWarehouseCode)"
                  matTooltipPosition="above"
                >
                  <i class="fas fa-warehouse"></i
                  >{{ getWarehouseName(ll.loadingListWarehouseCode) }}
                </span>
                <span
                  class="link-ll-meta-item"
                  *ngIf="ll.loadingListWarehousesToName"
                  [matTooltip]="ll.loadingListWarehousesToName"
                  matTooltipPosition="above"
                >
                  <i class="fas fa-route"></i
                  >{{ ll.loadingListWarehousesToName }}
                </span>
                <span
                  class="link-ll-meta-item link-ll-meta-item-sm"
                  [matTooltip]="
                    (ll.loadingListItemsCount || 0) +
                    ' coll' +
                    ((ll.loadingListItemsCount || 0) === 1 ? 'o' : 'i')
                  "
                  matTooltipPosition="above"
                >
                  <i class="fas fa-box"></i
                  >{{ ll.loadingListItemsCount || 0 }} coll{{
                    (ll.loadingListItemsCount || 0) === 1 ? "o" : "i"
                  }}
                </span>
                <span
                  class="link-ll-meta-item link-ll-meta-item-sm"
                  [matTooltip]="formatKg(ll.loadingListLoadedWeight)"
                  matTooltipPosition="above"
                >
                  <i class="fas fa-weight-hanging"></i
                  >{{ formatKg(ll.loadingListLoadedWeight) }}
                </span>
                <span
                  class="link-ll-meta-item link-ll-meta-item-sm"
                  [matTooltip]="formatM3(ll.loadingListLoadedVolume)"
                  matTooltipPosition="above"
                >
                  <i class="fas fa-cube"></i
                  >{{ formatM3(ll.loadingListLoadedVolume) }}
                </span>
              </div>
            </div>
          </div>
        </div>

        <div
          class="empty-state-inline"
          *ngIf="
            !linkLoadingListsLoading && availableLoadingListsToLink.length === 0
          "
        >
          <i class="fas fa-box-open me-2"></i>
          Nessun borderò disponibile da collegare
        </div>

        <div
          class="empty-state-inline"
          *ngIf="
            !linkLoadingListsLoading &&
            availableLoadingListsToLink.length > 0 &&
            filteredLoadingListsToLink.length === 0
          "
        >
          <i class="fas fa-filter me-2"></i>
          Nessun borderò corrisponde al filtro applicato
        </div>
      </div>
    </div>

    <!-- STEP 2: conferma -->
    <div class="popup-body" *ngIf="linkLoadingListsPopupStep === 'confirm'">
      <div class="link-ll-confirm-text">
        Confermi di voler collegare
        <b>{{ selectedLoadingListsToLinkCount }}</b> borderò al viaggio
        <b>{{ linkLoadingListsPopupTrip?.tripCode }}</b
        >?

        <ng-container *ngIf="selectedLoadingListsToLinkAlreadyLinkedCount > 0">
          <br /><br />
          <i
            class="fas fa-triangle-exclamation me-1"
            style="color: #d9a300"
          ></i>
          Il collegamento precedente verrà sostituito con questo.
        </ng-container>
      </div>

      <div class="link-ll-list mt-3">
        <ng-container *ngFor="let ll of availableLoadingListsToLink">
          <div
            class="link-ll-card static"
            *ngIf="isLoadingListSelectedToLink(ll)"
          >
            <div class="link-ll-main">
              <div
                class="d-flex justify-content-between align-items-center flex-wrap gap-2"
              >
                <span class="link-ll-code">
                  <i class="fas fa-clipboard-list me-2"></i
                  >{{ ll.loadingListCode }}
                </span>
                <span class="link-trip-badge" *ngIf="ll.loadingListTripCode">
                  <i class="fas fa-link"></i>
                  {{ ll.loadingListTripCode }}
                </span>
              </div>
            </div>
          </div>
        </ng-container>
      </div>
    </div>

    <div class="popup-footer" *ngIf="linkLoadingListsPopupStep === 'select'">
      <div class="d-flex justify-content-end gap-2">
        <button
          type="button"
          class="btn btn-outline-secondary"
          (click)="closeLinkLoadingListsPopup()"
        >
          Annulla
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="selectedLoadingListsToLinkCount === 0"
          (click)="goToConfirmLinkStep()"
        >
          Avanti ({{ selectedLoadingListsToLinkCount }})
        </button>
      </div>
    </div>

    <div class="popup-footer" *ngIf="linkLoadingListsPopupStep === 'confirm'">
      <div class="d-flex justify-content-end gap-2">
        <button
          type="button"
          class="btn btn-outline-secondary"
          [disabled]="linkingLoadingLists"
          (click)="backToSelectLinkStep()"
        >
          <i class="fas fa-arrow-left me-2"></i>Indietro
        </button>
        <button
          type="button"
          class="btn btn-primary"
          [disabled]="linkingLoadingLists"
          (click)="confirmLinkSelectedLoadingLists()"
        >
          <i
            class="fas"
            [ngClass]="linkingLoadingLists ? 'fa-spinner fa-spin' : 'fa-check'"
          ></i>
          Conferma collegamento
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Popup storico invio bolle -->
<div
  class="popup-overlay"
  *ngIf="docsHistoryPopupFor"
  (click)="closeDocsHistory()"
>
  <div
    class="popup-content docs-history-popup"
    (click)="$event.stopPropagation()"
  >
    <div class="popup-header">
      <h2 class="popup-title">
        <i class="fas fa-clock-rotate-left me-2"></i>
        Storico invio bolle
        <span class="docs-history-trip">{{
          docsHistoryPopupFor.tripCode
        }}</span>
      </h2>
      <button
        type="button"
        class="btn-close"
        (click)="closeDocsHistory()"
        aria-label="Close"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body docs-history-body">
      <div class="docs-history-state" *ngIf="docsHistoryLoading">
        <i class="fas fa-spinner fa-spin me-2"></i> Caricamento storico...
      </div>

      <div
        class="docs-history-state"
        *ngIf="!docsHistoryLoading && docsHistoryEvents.length === 0"
      >
        <i class="fas fa-inbox me-2"></i> Nessun evento registrato
      </div>

      <ul
        class="docs-timeline"
        *ngIf="!docsHistoryLoading && docsHistoryEvents.length > 0"
      >
        <li
          class="docs-timeline-item"
          *ngFor="let ev of docsHistoryEvents"
          [ngClass]="getDocsEventMeta(ev.tripDocsEventType).cssClass"
        >
          <span class="docs-timeline-dot">
            <i
              class="fas"
              [ngClass]="getDocsEventMeta(ev.tripDocsEventType).icon"
            ></i>
          </span>
          <div class="docs-timeline-content">
            <div class="docs-timeline-title">
              {{ getDocsEventMeta(ev.tripDocsEventType).label }}
            </div>
            <div class="docs-timeline-meta">
              <span
                ><i class="far fa-calendar me-1"></i
                >{{ formatDateTime(ev.tripDocsEventAt) }}</span
              >
              <span>
                <i
                  class="fas me-1"
                  [ngClass]="
                    ev.tripDocsEventBy === 'SYSTEM' ? 'fa-robot' : 'fa-user'
                  "
                ></i>
                {{ ev.tripDocsEventByName || ev.tripDocsEventBy || "-" }}
              </span>
            </div>
          </div>
        </li>
      </ul>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeDocsHistory()"
        >
          Chiudi
        </button>
      </div>
    </div>
  </div>
</div>

<div class="popup-overlay" *ngIf="showDeletePopup" (click)="closeDeletePopup()">
  <div class="popup-content delete-popup" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h2 class="popup-title">
        <i class="fas fa-trash me-2"></i>
        Elimina Borderò
      </h2>

      <button
        type="button"
        class="btn-close"
        (click)="closeDeletePopup()"
        aria-label="Close"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <div class="alert alert-light border mb-3">
        Sicuro di voler eliminare il borderò
        <b class="ms-1">{{
          deleteTarget?.loadingListCode || deleteTarget?.loadingListId
        }}</b>
        ?
      </div>

      <div class="mb-2 text-muted small">
        <i class="fas fa-info-circle me-1"></i>
        L’operazione non è reversibile.
      </div>

      <div class="mt-3" *ngIf="requireDeleteTextConfirm">
        <label class="form-label">Scrivi <b>ELIMINA</b> per confermare</label>
        <input
          type="text"
          class="form-control"
          [(ngModel)]="deleteConfirmText"
          placeholder="ELIMINA"
        />
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end gap-2">
        <button
          type="button"
          class="btn btn-secondary"
          (click)="closeDeletePopup()"
          [disabled]="deleting"
        >
          Annulla
        </button>

        <button
          type="button"
          class="btn btn-danger"
          (click)="confirmDeletePopup()"
          [disabled]="
            deleting ||
            (requireDeleteTextConfirm && deleteConfirmText !== 'ELIMINA')
          "
        >
          <span *ngIf="!deleting">
            <i class="fas fa-trash me-2"></i>Elimina
          </span>
          <span *ngIf="deleting">
            <i class="fas fa-spinner fa-spin me-2"></i>Eliminazione...
          </span>
        </button>
      </div>
    </div>
  </div>
</div>

<!-- Popup "Sfila da questo viaggio" -->
<div
  class="popup-overlay"
  *ngIf="detachPopupFor"
  (click)="closeDetachLoadingListPopup()"
>
  <div class="popup-content" (click)="$event.stopPropagation()">
    <div class="popup-header">
      <h2 class="popup-title">
        <i class="fas fa-link-slash me-2"></i>
        Sfila da questo viaggio
      </h2>
      <button
        type="button"
        class="btn-close"
        (click)="closeDetachLoadingListPopup()"
        aria-label="Close"
      >
        <i class="fas fa-times"></i>
      </button>
    </div>

    <div class="popup-body">
      <div class="alert alert-light border mb-3">
        Confermi di voler sfilare il borderò
        <b class="ms-1">{{ detachPopupFor.ll.loadingListCode }}</b>
        dal viaggio <b>{{ detachPopupFor.trip.tripCode }}</b
        >?
      </div>

      <div class="mb-2 text-muted small">
        <i class="fas fa-info-circle me-1"></i>
        Il borderò verrà scollegato da questo viaggio e verrà creato un
        <b>nuovo viaggio</b> contenente solo questo borderò.
      </div>

      <div
        class="alert alert-danger py-2 px-3 small mb-0 mt-3"
        *ngIf="detachError"
      >
        <i class="fas fa-exclamation-triangle me-2"></i>{{ detachError }}
      </div>
    </div>

    <div class="popup-footer">
      <div class="d-flex justify-content-end gap-2">
        <button
          type="button"
          class="btn btn-secondary"
          [disabled]="detaching"
          (click)="closeDetachLoadingListPopup()"
        >
          Annulla
        </button>
        <button
          type="button"
          class="btn btn-detach-confirm"
          [disabled]="detaching"
          (click)="confirmDetachLoadingList()"
        >
          <span *ngIf="!detaching"
            ><i class="fas fa-link-slash me-2"></i> Conferma</span
          >
          <span *ngIf="detaching"
            ><i class="fas fa-spinner fa-spin me-2"></i> Scollegamento...</span
          >
        </button>
      </div>
    </div>
  </div>
</div>